import React, { useState, useEffect, useRef } from 'react';
import PrivacyAccordion from './components/PrivacyAccordion';
import AllegatoAccordion from './components/AllegatoAccordion';
import SalesConditions from './components/SaleConditions';
import PdfFormFiller from './components/PdfTemplate';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import tooltip from "./data/tooltip"
import countries from "./data/countryNascita"
import mesiNascita from "./data/mesiNascita"
import staticText from "./data/staticText"
import provinceItaliane from "./data/province";
import countryList from "react-select-country-list";
import Select from "react-select";
import LastPage from './components/LastPage';
import comuniData from './data/comuniItaliani.json';
import comuniResidenza from './data/comuniResidenza.json';
import axios from "axios"
import JSZip from "jszip";
import { generatePdfBlob } from "./utils/pdfUtils";
import './App.css'

function App() {

  const [generatePdf, setGeneratePdf] = useState(false);
  const [page, setPage] = useState(1);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [isCodeValid, setIsCodeValid] = useState(false);
  const [isDomicileEnabled, setIsDomicileEnabled] = useState(false);
  const [isDomicileTitolareEnabled, setIsDomicileTitolareEnabled] = useState(false);


  //STATO, PROVINCIA E COMUNE -> VARIABILI AUSILIARIE
  const [filteredComuni, setFilteredComuni] = useState([]);
  const [filteredComuniTitolare, setFilteredComuniTitolare] = useState([]);
  const [filteredComuniDitta, setFilteredComuniDitta] = useState([]);
  const [filteredComuniRes, setFilteredComuniRes] = useState([]);
  const [filteredComuniDom, setFilteredComuniDom] = useState([]);
  const [filteredComuniResTitolare, setFilteredComuniResTitolare] = useState([]);
  const [filteredComuniDomTitolare, setFilteredComuniDomTitolare] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedProvinceDitta, setSelectedProvinceDitta] = useState("");
  const [selectedProvinceDom, setSelectedProvinceDom] = useState("");
  const [selectedProvinceNascita, setSelectedProvinceNascita] = useState("");
  const [selectedProvinceNascitaTitolare, setSelectedProvinceNascitaTitolare] = useState("");
  const [selectedProvinceTitolare, setSelectedProvinceTitolare] = useState("");
  const [selectedProvinceDomTitolare, setSelectedProvinceDomTitolare] = useState("");
  const [isItaly, setIsItaly] = useState(true);
  const [isItalyDitta, setIsItalyDitta] = useState(true);
  const [isItalyTitolare, setIsItalyTitolare] = useState(true);
  const [isItalyNascita, setIsItalyNascita] = useState(true);
  const [isItalyNascitaTitolare, setIsItalyNascitaTitolare] = useState(true);
  const [isItalyDom, setIsItalyDom] = useState(true);
  const [isItalyDomTitolare, setIsItalyDomTitolare] = useState(true);

  const [valuesSDI, setValuesSDI] = useState(Array(7).fill(''));
  const [emailNewsletter, setEmailNewsletter] = useState('');

  const [isDittaIndividuale, setIsDittaIndividuale] = useState(false);
  const [showDittaRadio, setShowDittaRadio] = useState(false); // to control the visibility of dittaRadio

  const [salesConditionChecked, setSalesConditionChecked] = useState(false);
  const [salesConditionArticleChecked, setSalesConditionArticleChecked] = useState(false);
  const [allAccordionsOpen, setAllAccordionsOpen] = useState(false);


  const [isConsentDenied, setIsConsentDenied] = useState(false);
  const [checkboxTuttiStates, setCheckboxTuttiStates] = useState({
    tutti: false,
    arteModerna: false,
    dipinti: false,
    orologi: false,
    vini: false,
    gioielli: false,
    antiquariato: false,
    tappeti: false,
    luxury: false,
  });
  const [isCodFiscaleRequired, setIsCodFiscaleRequired] = useState(false);
  const [isCodFiscaleTitolareRequired, setIsCodFiscaleTitolareRequired] = useState(false);

  const [isPepSelected, setIsPepSelected] = useState(false);
  const [isPepTitolareSelected, setIsPepTitolareSelected] = useState(false);
  const [isTitolareSelected, setIsTitolareSelected] = useState(false);
  const [consensoA, setConsensoA] = useState("");
  const [consensoB1, setConsensoB1] = useState("");
  const [consensoB2, setConsensoB2] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [canProceed, setCanProceed] = useState(false);

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];

  const [isRequired, setIsRequired] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFilesTitolare, setUploadedFilesTitolare] = useState([]);
  const allowedFormats = ["pdf", "doc", "docx", "png", "jpg"];
  const maxSize = 5 * 1024 * 1024;



  const handleCodeValidation = (isValid) => {
    setIsCodeValid(isValid);
  };

  const handleRequired = () => {
    setIsRequired(!isRequired);
  };


  useEffect(() => {
    if (!isDittaIndividuale && page === 3) {
      setPage(4);
    }
  }, [isDittaIndividuale, page]);



  const handleArticleCheckboxChange = (e) => {
    setSalesConditionArticleChecked(e.target.checked);

    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked, // Update the specific checkbox in formData
    }));
  };

  const handleCheckboxChange = (e) => {
    setSalesConditionChecked(e.target.checked);
    const { name, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));

  };

  const handleCheckboxAuth = () => {
    setIsAuthorized(prevState => !prevState);
    setFormData((prevData) => ({
      ...prevData,
      autorizzoConsenso: !isAuthorized,
    }));
  };


  //FUNZIONI PER LE PROVINCE


  const handleProvinciaChange = (event) => {
    const selectedProvincia = event.target.value;

    setFormData((prevData) => ({
      ...prevData,
      provincia: selectedProvincia,
      comuneResid: '',
      cap: '',
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltratiRes = comuniResidenza.comuniResidenza.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );

    setFilteredComuniRes(comuniFiltratiRes);
  };


  const handleProvinciaNascitaChange = (e) => {
    const selectedProvincia = e.target.value;

    if (selectedProvincia) {
      setSelectedProvinceNascita(true); // Abilita il luogo di nascita
    } else {
      setSelectedProvinceNascita(false); // Disabilita il luogo di nascita
    }

    setFormData((prev) => ({
      ...prev,
      provinciaNascita: selectedProvincia,
      comuneNascita: '',
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltrati = comuniData.comuniItaliani.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );
    setFilteredComuni(comuniFiltrati)
  };


  const handleProvinciaNascitaTitolareChange = (e) => {
    const selectedProvincia = e.target.value;

    if (selectedProvincia) {
      setSelectedProvinceNascitaTitolare(true); // Abilita il luogo di nascita
    } else {
      setSelectedProvinceNascitaTitolare(false); // Disabilita il luogo di nascita
    }

    setFormData((prev) => ({
      ...prev,
      provinciaNascitaTitolare: selectedProvincia,
      comuneNascitaTitolare: '',
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltrati = comuniData.comuniItaliani.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );
    setFilteredComuniTitolare(comuniFiltrati)
  };

  const handleProvinciaDomChange = (e) => {
    const selectedProvincia = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      provDom: selectedProvincia,
      comuneDom: '', // Reset del comune
      capDom: '', // Reset del CAP
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltratiDom = comuniResidenza.comuniResidenza.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );

    setFilteredComuniDom(comuniFiltratiDom);
  };


  const handleProvinciaTitolareChange = (e) => {
    const selectedProvincia = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      provinciaTitolare: selectedProvincia,
      comuneResidTitolare: '', // Reset del comune
      capTitolare: '', // Reset del CAP
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltratiRes = comuniResidenza.comuniResidenza.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );

    setFilteredComuniResTitolare(comuniFiltratiRes);
  };

  const handleProvinciaTitolareDomChange = (e) => {
    const selectedProvincia = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      provDomTitolare: selectedProvincia,
      comuneDomTitolare: '', // Reset del comune
      capDomTitolare: '', // Reset del CAP
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltrati = comuniResidenza.comuniResidenza.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );

    setFilteredComuniDomTitolare(comuniFiltrati);
  };

  const handleProvinciaDittaChange = (e) => {
    const selectedProvincia = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      provDitta: selectedProvincia,
      comuneDitta: '', // Reset del comune
      capDitta: '', // Reset del CAP
    }));

    // Filtra i comuni in base alla provincia selezionata
    const comuniFiltrati = comuniResidenza.comuniResidenza.filter(
      (comune) => comune.PROVINCIA === selectedProvincia
    );

    setFilteredComuniDitta(comuniFiltrati);
  };


  //FUNZIONI PER I COMUNI
  const handleComuneChange = (event) => {
    const selectedComune = event.target.value;

    // Trova i dettagli del comune selezionato
    const comuneDetails = filteredComuniRes.find(
      (comune) => comune.LOCALITA === selectedComune
    );

    setFormData((prevData) => ({
      ...prevData,
      comuneResid: selectedComune,
      cap: comuneDetails?.CAP || '',
    }));
  };

  const handleComuneDittaChange = (event) => {
    const selectedComune = event.target.value;

    // Trova i dettagli del comune selezionato
    const comuneDetails = filteredComuniDitta.find(
      (comune) => comune.LOCALITA === selectedComune
    );

    setFormData((prevData) => ({
      ...prevData,
      comuneDitta: selectedComune,
      capDitta: comuneDetails?.CAP || '',
    }));
  };

  const handleComuneDomChange = (event) => {
    const selectedComune = event.target.value;

    // Trova i dettagli del comune selezionato
    const comuneDetails = filteredComuniDom.find(
      (comune) => comune.LOCALITA === selectedComune
    );

    setFormData((prevData) => ({
      ...prevData,
      comuneDom: selectedComune,
      capDom: comuneDetails?.CAP || '', // Imposta il CAP o lascia vuoto
    }));
  };

  const handleComuneTitolareChange = (event) => {
    const selectedComune = event.target.value;

    // Trova i dettagli del comune selezionato
    const comuneDetails = filteredComuniResTitolare.find(
      (comune) => comune.LOCALITA === selectedComune
    );

    setFormData((prevData) => ({
      ...prevData,
      comuneResidTitolare: selectedComune,
      capTitolare: comuneDetails?.CAP || '', // Imposta il CAP o lascia vuoto
    }));
  };


  const handleComuneTitolareDomChange = (event) => {
    const selectedComune = event.target.value;

    // Trova i dettagli del comune selezionato
    const comuneDetails = filteredComuniDomTitolare.find(
      (comune) => comune.LOCALITA === selectedComune
    );

    setFormData((prevData) => ({
      ...prevData,
      comuneDomTitolare: selectedComune,
      capDomTitolare: comuneDetails?.CAP || '', // Imposta il CAP o lascia vuoto
    }));
  };


  //FUNZIONI PER GLI STATI
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedCountryNascita, setSelectedCountryNascita] = useState('');


  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      stato: selectedCountry,
      provincia: '',  // Reset provincia
      comuneResid: '',  // Reset comuneResid
      cap: '',
      localitaResid: selectedCountry === 'IT' ? '' : prev.localitaResid
    }));

    if (selectedCountry === 'IT') {
      setIsItaly(true); // Enable provincia and comune
      setSelectedProvince(false);
    } else {
      setIsItaly(false); // Disable provincia and comune
      setSelectedProvince(true);
    }
  };


  const handleCountryDittaChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      statoDitta: selectedCountry,
      provDitta: '', // Reset della provincia
      comuneDitta: '', // Reset o mantiene il luogo a seconda del paese
      capDitta: '',
      localitaDitta: selectedCountry === 'IT' ? '' : prev.localitaDitta
    }));

    // Imposta se la provincia è richiesta
    if (selectedCountry === 'IT') {
      setIsItalyDitta(true);
      setSelectedProvinceDitta(false);
    } else {
      setIsItalyDitta(false);
      setSelectedProvinceDitta(true);
    }
  };
  const handleCountryTitolareChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      statoTitolare: selectedCountry,
      provinciaTitolare: '', // Reset della provincia
      comuneResidTitolare: '', // Reset o mantiene il luogo a seconda del paese
      capTitolare: '',
      localitaResidTitolare: selectedCountry === 'IT' ? '' : prev.localitaResidTitolare
    }));

    // Imposta se la provincia è richiesta
    if (selectedCountry === 'IT') {
      setIsItalyTitolare(true); // Abilita la provincia
      setSelectedProvinceTitolare(false); // Disabilita temporaneamente il luogo di nascita
    } else {
      setIsItalyTitolare(false); // Disabilita la provincia
      setSelectedProvinceTitolare(true); // Abilita il luogo di nascita
    }
  };

  const handleCountryNascitaChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      statoNascita: selectedCountry,
      provinciaNascita: '', // Reset della provincia
      comuneNascita: '', // Reset o mantiene il luogo a seconda del paese
      luogoNascita: ''
    }));

    // Imposta se la provincia è richiesta
    if (selectedCountry === 'IT') {
      setIsItalyNascita(true); // Abilita la provincia
      setSelectedProvinceNascita(false); // Disabilita temporaneamente il luogo di nascita
    } else {
      setIsItalyNascita(false); // Disabilita la provincia
      setSelectedProvinceNascita(true); // Abilita il luogo di nascita
    }

  };


  const handleCountryNascitaTitolareChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      statoNascitaTitolare: selectedCountry,
      provinciaNascitaTitolare: '',
      comuneNascitaTitolare: '',
      luogoNascitaTitolare: ''
    }));

    // Imposta se la provincia è richiesta
    if (selectedCountry === 'IT') {
      setIsItalyNascitaTitolare(true); // Abilita la provincia
      setSelectedProvinceNascitaTitolare(false); // Disabilita temporaneamente il luogo di nascita
    } else {
      setIsItalyNascitaTitolare(false); // Disabilita la provincia
      setSelectedProvinceNascitaTitolare(true); // Abilita il luogo di nascita
    }

  };

  const handleCountryDomChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      statoDom: selectedCountry,
      provDom: '', // Reset della provincia
      comuneDom: '', // Reset o mantiene il luogo a seconda del paese
      capDom: '',
      localitaDom: selectedCountry === 'IT' ? '' : prev.localitaDom
    }));

    // Imposta se la provincia è richiesta
    if (selectedCountry === 'IT') {
      setIsItalyDom(true); // Abilita la provincia
      setSelectedProvinceDom(false); // Disabilita temporaneamente il luogo di nascita
    } else {
      setIsItalyDom(false); // Disabilita la provincia
      setSelectedProvinceDom(true); // Abilita il luogo di nascita
    }
  };


  const handleCountryTitolareDomChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      statoDomTitolare: selectedCountry,
      provDomTitolare: '', // Reset della provincia
      comuneDomTitolare: '', // Reset o mantiene il luogo a seconda del paese
      capDomTitolare: '',
      localitaDomTitolare: selectedCountry === 'IT' ? '' : prev.localitaDomTitolare
    }));

    // Imposta se la provincia è richiesta
    if (selectedCountry === 'IT') {
      setIsItalyDomTitolare(true); // Abilita la provincia
      setSelectedProvinceDomTitolare(false); // Disabilita temporaneamente il luogo di nascita
    } else {
      setIsItalyDomTitolare(false); // Disabilita la provincia
      setSelectedProvinceDomTitolare(true); // Abilita il luogo di nascita
    }


  }


  // Function to handle individual checkbox changes and update the "Tutti" checkbox based on their states
  const handleTuttiCheckboxChange = (e, checkboxName) => {
    const isChecked = e.target.checked;

    // Update individual checkbox state
    setCheckboxTuttiStates((prevState) => {
      const updatedState = { ...prevState, [checkboxName]: isChecked };

      // Check if all individual checkboxes are selected to update 'Tutti' checkbox
      const allChecked = Object.entries(updatedState)
        .filter(([key]) => key !== "tutti") // Exclude the 'Tutti' checkbox
        .every(([_, value]) => value === true);

      return { ...updatedState, tutti: allChecked }; // Update the 'Tutti' checkbox
    });

    // Update formData to reflect the individual checkbox changes
    setFormData((prevData) => ({
      ...prevData,
      [`checkbox${checkboxName.charAt(0).toUpperCase() + checkboxName.slice(1)}`]: isChecked, // Update specific checkbox in formData
      checkboxTutti: checkboxName === 'tutti' ? isChecked : prevData.checkboxTutti, // Update 'Tutti' checkbox if necessary
    }));
  };




  // Function to handle the consent change (allow/deny)
  const handleConsensoAChange = (e) => {
    const value = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      consensoA: value, // Update consensoA in formData
      emailNewsletter: value === "deny" ? "" : prevData.emailNewsletter, // Clear email if "deny"
    }));

    if (value === "allow") {
      setIsConsentGiven(true);
      setIsConsentDenied(false);
      setIsRequired(true);
      setCheckboxTuttiStates((prevState) => {
        const updatedState = Object.keys(prevState).reduce((acc, key) => {
          acc[key] = false; // Uncheck all checkboxes
          return acc;
        }, {});
        return { ...updatedState, tutti: false }; // Ensure "Tutti" is also unchecked
      });
    } else if (value === "deny") {
      setIsConsentGiven(false);
      setIsConsentDenied(true);
      setIsRequired(false); // Make email required
      setCheckboxTuttiStates((prevState) => {
        const updatedState = Object.keys(prevState).reduce((acc, key) => {
          acc[key] = false; // Uncheck all checkboxes
          return acc;
        }, {});
        return { ...updatedState, tutti: false }; // Ensure "Tutti" is unchecked
      });
    }

    setConsensoA(value); // Update the consensoA state
  };


  const handleConsensoB1Change = (e) => {
    const value = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      consensoB1: value, // Update consensoA in formData
    }));
  };

  const handleConsensoB2Change = (e) => {
    const value = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      consensoB2: value, // Update consensoA in formData
    }));
  };


  const [showAllegato, setShowAllegato] = useState(false);

  const handleAllegato = () => {
    setShowAllegato((prevState) => !prevState); // Toggle visibility
  };



  //FUNZIONI PER IL CODICE SDI
  const handleChangeSDI = (e, index) => {
    const input = e.target.value.toUpperCase();

    // Validate input to only allow alphanumeric characters or empty
    if (/^[A-Z0-9]$/.test(input) || input === '') {
      const newValues = [...valuesSDI];
      newValues[index] = input;
      setValuesSDI(newValues);

      // Update formData with the concatenated SDI value
      const newSdiCode = newValues.join('');
      setFormData((prevData) => ({
        ...prevData,
        sdiCode: newSdiCode, // Update SDI code in formData
      }));

      // Move to the next input if there is any input
      if (input && index < valuesSDI.length - 1) {
        const nextInput = document.getElementById(`sdi${index + 2}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleKeyDownSDI = (e, index) => {
    if (e.key === 'Backspace' && valuesSDI[index] === '' && index > 0) {
      const prevInput = document.getElementById(`sdi${index}`);
      if (prevInput) prevInput.focus();
    }
  };


  //GESTIONE RADIO PEP E TITOLARE
  const handlePepChange = (isSelected) => {
    setIsPepSelected(isSelected);
    setFormData((prevData) => ({
      ...prevData,
      pepOption: isSelected ? "pep" : "nonPep",
      pepText: isSelected ? prevData.pepText : ""
    }));
  };

  const handleTitolareChange = (isSelected) => {
    setIsTitolareSelected(isSelected);
    setFormData((prevData) => ({
      ...prevData,
      titolareOption: isSelected ? "thirdParty" : "ownAccount", // Set the radio button value
      pepTitolareOption: "nonPepTitolare", // Forziamo il reset a "nonPepTitolare" quando passiamo a "ownAccount"
      pepTitolareText: isSelected ? prevData.pepTitolareText : "", // Clear the text area if "ownAccount" is selected

      // Clear 'titolare' fields if selecting 'ownAccount'
      ...(isSelected
        ? {} // Don't modify 'titolare' data if 'thirdParty' is selected
        : {
          nomeTitolare: '', cognomeTitolare: '', dataNascitaTitolare: '', provinciaNascitaTitolare: '', comuneNascitaTitolare: '', luogoNascitaTitolare: '', indirizzoTitolare: '', pepTitolareOption: 'nonPepTitolare',
          numCivTitolare: '', provinciaTitolare: '', comuneResidTitolare: '', capTitolare: '', localitaResidTitolare: '', codiceFiscaleTitolare: '', provDomTitolare: '',
          capDomTitolare: '', comuneDomTitolare: '', indirizzoDomTitolare: '', numCivDomTitolare: '', localitaDomTitolare: '', tipoDocTitolare: '', numDocTitolare: '', dataDocTitolare: '',
          dataScadDocTitolare: '', rilascioDocTitolare: '', docsTitolare: '', relTitolare: '', pepTitolareText: '', statoNascitaTitolare: 'IT', statoTitolare: 'IT', statoDomTitolare: 'IT'
        }
      ),


    }));

    if (!isSelected) {
      removeFilesTitolare();
      setIsPepTitolareSelected(false);
    }
  };


  const handlePepTitolareChange = (isSelected) => {
    setIsPepTitolareSelected(isSelected);
    setFormData((prevData) => ({
      ...prevData,
      pepTitolareOption: isSelected ? "pepTitolare" : "nonPepTitolare",
      pepTitolareText: isSelected ? prevData.pepTitolareText : ""
    }));
  };

  //FUNZIONE PER CHECKBOX "TUTTI"

  //Gestisce il caso in cui "Presto il consenso" sia stato premuto
  const [isConsentGiven, setIsConsentGiven] = useState(false);

  const handleTuttiChange = (e) => {
    const isChecked = e.target.checked;
    setCheckboxTuttiStates((prevState) => {
      const updatedState = {
        ...prevState,
        tutti: isChecked,
        arteModerna: isChecked,
        dipinti: isChecked,
        orologi: isChecked,
        vini: isChecked,
        gioielli: isChecked,
        antiquariato: isChecked,
        tappeti: isChecked,
        luxury: isChecked,
      };
      return updatedState;
    });

    // Update formData when 'Tutti' checkbox is clicked
    setFormData((prevData) => ({
      ...prevData,
      checkboxArteModerna: isChecked,
      checkboxDipinti: isChecked,
      checkboxOrologi: isChecked,
      checkboxVini: isChecked,
      checkboxGioielli: isChecked,
      checkboxAntiquariato: isChecked,
      checkboxTappeti: isChecked,
      checkboxLuxury: isChecked,
      checkboxTutti: isChecked, // Update 'Tutti' field in formData
    }));
  };


  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9\s]/g, "");
  };


  const createZip = async (docs, docsTitolare, nome, cognome, authCode) => {
    const zip = new JSZip();

    docs.forEach((file) => {
      zip.file(file.name, file);
    });

    docsTitolare.forEach((file) => {
      zip.file(file.name, file);
    });

    // Normalizzo nome e cognome rimuovendo accenti e sostituendo gli spazi con "_"
    const sanitizedNome = removeAccents(nome).replace(/\s+/g, "_");
    const sanitizedCognome = removeAccents(cognome).replace(/\s+/g, "_");

    // nome del file ZIP con il formato "cognome_nome_authCode.zip"
    const zipFileName = `${sanitizedCognome}_${sanitizedNome}_${authCode}.zip`;

    const zipBlob = await zip.generateAsync({ type: "blob" });

    return { zipBlob, zipFileName };
  };





  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);


    const isValid = validateFields();
    if (!isValid) {
      console.log("Validation failed, submission halted.");
      setLoading(false);
      return;
    }

    // Extract file names
    const docs = formData.docs || [];
    const docsTitolare = formData.docsTitolare || [];

    const updatedFormData = {
      ...formData,
      docs: (formData.docs || []).map(file => file.name),
      docsTitolare: (formData.docsTitolare || []).map(file => file.name),
    };

    try {

      //GENERAZIONE PDF
      //console.log(formData);

      const pdfBlob = await generatePdfBlob(updatedFormData);
      const sanitizedNome = removeAccents(updatedFormData.nome).replace(/\s+/g, "_");
      const sanitizedCognome = removeAccents(updatedFormData.cognome).replace(/\s+/g, "_");
      const pdfFileName = `${sanitizedCognome}_${sanitizedNome}_Modulo.pdf`;
      const pdfFile = new File([pdfBlob], pdfFileName, { type: "application/pdf" });

      const allDocs = [...docs, pdfFile];

      // Create the zip file
      const { zipBlob, zipFileName } = await createZip(allDocs, docsTitolare, updatedFormData.nome, updatedFormData.cognome, updatedFormData.authCode);

      const formDataWithZip = new FormData();
      formDataWithZip.append("file", zipBlob, zipFileName);

      const ftpUploadResponse = await axios.post(
        "https://meetingartreg-backend.onrender.com/api/upload",
        formDataWithZip,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (ftpUploadResponse.status === 200) {
        console.log("ZIP file uploaded successfully!");

        const insertResponse = await axios.post(
          "https://meetingartreg-backend.onrender.com/api/insert",
          updatedFormData
        );

        if (insertResponse.status === 200) {
          // console.log("Data inserted successfully:", insertResponse.data.message);
          setPage(11);

          const emailResponse = await fetch('https://meetingartreg-backend.onrender.com/api/send-email', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              to: 'registrazioni@meetingart.it',
              subject: 'Nuova Registrazione',
              nome: formData.nome,
              cognome: formData.cognome,
              code: formData.authCode,
              emailType: 'registration',
              zipFileName: zipFileName,
            }),
          });

          setGeneratePdf(true);
        } else {
          console.error("Failed to insert data:", insertResponse.data.error);
        }
      } else {
        console.error("Failed to upload ZIP file via FTP:", ftpUploadResponse.data.error);
      }
    } catch (error) {
      console.error("Error during submission:", error.response ? error.response.data : error.message);
    }
    finally {
      setLoading(false);
    }
  };

  const currentDate = new Date().toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });


  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    nationality: '',
    entityRadio: '',
    nome: '',
    cognome: '',
    sesso: '',
    indirizzo: '',
    numCiv: '',
    stato: 'IT',
    provincia: '',
    comuneResid: '',
    cap: '',
    localitaResid: '',
    telefono: '',
    cellulare: '',
    fax: '',
    email: '',
    pec: '',
    dataNascita: '',
    statoNascita: 'IT',
    provinciaNascita: '',
    comuneNascita: '',
    luogoNascita: '',
    codiceFiscale: '',
    tipoDoc: '',
    numDoc: '',
    dataDoc: '',
    dataScadDoc: '',
    rilascioDoc: '',
    docs: '',
    ragSociale: '',
    indirizzoDitta: '',
    numCivDitta: '',
    statoDitta: '',
    provDitta: '',
    comuneDitta: '',
    capDitta: '',
    localitaDitta: '',
    telefonoDitta: '',
    faxDitta: '',
    emailDitta: '',
    pIva: '',
    pecDitta: '',
    sdiCode: '',
    provDom: '',
    capDom: '',
    localitaDom: '',
    indirizzoDom: '',
    statoDom: 'IT',
    numCivDom: '',
    comuneDom: '',
    emailNewsletter: '',
    nomeTitolare: '',
    cognomeTitolare: '',
    sessoTitolare: '',
    dataNascitaTitolare: '',
    statoNascitaTitolare: 'IT',
    provinciaNascitaTitolare: '',
    comuneNascitaTitolare: '',
    luogoNascitaTitolare: '',
    indirizzoTitolare: '',
    numCivTitolare: '',
    statoTitolare: 'IT',
    provinciaTitolare: '',
    comuneResidTitolare: '',
    capTitolare: '',
    localitaResidTitolare: '',
    codiceFiscaleTitolare: '',
    provDomTitolare: '',
    capDomTitolare: '',
    comuneDomTitolare: '',
    indirizzoDomTitolare: '',
    statoDomTitolare: 'IT',
    numCivDomTitolare: '',
    localitaDomTitolare: '',
    tipoDocTitolare: '',
    numDocTitolare: '',
    dataDocTitolare: '',
    dataScadDocTitolare: '',
    rilascioDocTitolare: '',
    docsTitolare: '',
    relTitolare: '',
    pepTitolareText: '',
    profCli: '',
    autorizzoConsenso: '',
    salesConditionArticle: false,
    salesCondition: false,
    consensoA: '',
    consensoB1: '',
    consensoB2: '',
    checkboxTutti: false,  // Track 'Tutti' checkbox
    checkboxArteModerna: false,
    checkboxDipinti: false,
    checkboxOrologi: false,
    checkboxVini: false,
    checkboxGioielli: false,
    checkboxAntiquariato: false,
    checkboxTappeti: false,
    checkboxLuxury: false,
    pepOption: "nonPep",
    titolareOption: "ownAccount",
    pepTitolareOption: "nonPepTitolare",
    mandatoVendereBeni: false,
    compravenditaBeni: false,
    consulenza: false,
    stime: false,
    altroTipRapporto: false,
    altroTipRapportoDescription: "",
    investimentoPersonale: false,
    investimentoProfessionale: false,
    smobilizzoInvestimento: false,
    investimentoCommerciale: false,
    altroScRapporto: false,
    altroScRapportoDescription: "",
    pepText: '',
    authCode: '',
    randomCode: '',
    luogoForm: '',
    dataForm: currentDate
  });

  const [isAltroScRapportoSelected, setIsAltroScRapportoSelected] = useState(false);
  const [isAltroTipRapportoSelected, setIsAltroTipRapportoSelected] = useState(false);

  // State to track the checkboxes' values
  const [scRapportoChecks, setScRapportoChecks] = useState({
    investimentoPersonale: false,
    investimentoProfessionale: false,
    smobilizzoInvestimento: false,
    investimentoCommerciale: false,
  });

  const [tipRapportoChecks, setTipRapportoChecks] = useState({
    mandatoVendereBeni: false,
    compravenditaBeni: false,
    consulenza: false,
    stime: false,
  });


  // When "Altro" is selected in scopoRapporto, we clear all other selected checkboxes
  const handleAltroScRapportoChange = (e) => {
    const isChecked = e.target.checked;

    // Update formData and local state for the "Altro" checkbox
    setFormData((prevData) => ({
      ...prevData,
      altroScRapporto: isChecked,
      ...(isChecked ? {} : { altroScRapportoDescription: "" }),
      ...(isChecked
        ? {
          investimentoPersonale: false,
          investimentoProfessionale: false,
          smobilizzoInvestimento: false,
          investimentoCommerciale: false,
        }
        : {}),
    }));

    // Update the local state to ensure proper UI rendering
    setIsAltroScRapportoSelected(isChecked);

    if (isChecked) {
      setScRapportoChecks({
        investimentoPersonale: false,
        investimentoProfessionale: false,
        smobilizzoInvestimento: false,
        investimentoCommerciale: false,
      });
    }
  };


  // Handle change for individual checkboxes
  const handleScCheckboxChange = (key) => {
    // Update local state and formData in sync
    setScRapportoChecks((prevChecks) => {
      const updatedChecks = { ...prevChecks, [key]: !prevChecks[key] };

      // Update the formData state
      setFormData((prevData) => ({
        ...prevData,
        [key]: updatedChecks[key], // Update formData with the new checkbox state
      }));

      return updatedChecks;
    });
  };

  const handleAltroScDescriptionChange = (e) => {
    const description = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      altroScRapportoDescription: description,
    }));
  };

  // When "Altro" is selected in tipoRapporto, we clear all other selected checkboxes
  const handleAltroTipRapportoChange = (e) => {
    const isChecked = e.target.checked;

    // Update local state and formData synchronously
    setFormData((prevData) => ({
      ...prevData,

      altroTipRapporto: isChecked,
      ...(isChecked ? {} : { altroTipRapportoDescription: "" }),
      ...(isChecked
        ? {
          mandatoVendereBeni: false,
          compravenditaBeni: false,
          consulenza: false,
          stime: false,
        }
        : {}),
    }));

    setIsAltroTipRapportoSelected(isChecked);

    if (isChecked) {
      // Reset other checkboxes when "Altro" is selected
      setTipRapportoChecks({
        mandatoVendereBeni: false,
        compravenditaBeni: false,
        consulenza: false,
        stime: false,
      });
    }
  };

  const handleCheckboxTipRapportoChange = (key) => {
    // Update local state and formData in sync
    setTipRapportoChecks((prevChecks) => {
      const updatedChecks = { ...prevChecks, [key]: !prevChecks[key] };

      setFormData((prevData) => ({
        ...prevData,
        [key]: updatedChecks[key], // Update formData with the new checkbox state
      }));

      return updatedChecks;
    });
  };
  // Handle change for the "Altro" text description
  const handleAltroDescriptionChange = (e) => {
    const description = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      altroTipRapportoDescription: description,
    }));
  };

  useEffect(() => {
    if ((formData.stato !== "IT" && formData.statoNascita !== "IT")) {
      setIsCodFiscaleRequired(false);
    } else {
      setIsCodFiscaleRequired(true);
    }

  }, [formData.stato, formData.statoNascita]);

  useEffect(() => {
    if ((formData.statoTitolare !== "IT" && formData.statoNascitaTitolare !== "IT")) {
      setIsCodFiscaleTitolareRequired(false);
    } else {
      setIsCodFiscaleTitolareRequired(true);
    }

  }, [formData.statoTitolare, formData.statoNascitaTitolare]);

  useEffect(() => {
    // Controlla che almeno un'opzione per ogni radio button sia selezionata
    if (isAuthorized && formData.consensoA !== "" && formData.consensoB1 !== "" && formData.consensoB2 !== "") {
      setCanProceed(true);
    } else {
      setCanProceed(false);
    }
  }, [isAuthorized, formData.consensoA, formData.consensoB1, formData.consensoB2]);



  const [isItalianResident, setIsItalianResident] = useState(false); // True for 'Sì', False for 'No'

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    // Gestione valori aggiornati
    const updatedValue =
      name === "codiceFiscale" || name === "codiceFiscaleTitolare"
        ? value.toUpperCase()
        : value;

    // Gestione file multipli
    const newFiles = files ? Array.from(files) : [];

    if (name === "docs") {
      setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]); // Update local uploaded files
      setFormData((prevData) => ({
        ...prevData,
        docs: [...(prevData.docs || []), ...newFiles], // Safely spread existing files or default to an empty array
      }));
      //validateFields({ docs: [...uploadedFiles, ...newFiles] });
      return;
    }

    if (name === "docsTitolare") {
      setUploadedFilesTitolare((prevFiles) => [...prevFiles, ...newFiles]); // Update local uploaded files
      setFormData((prevData) => ({
        ...prevData,
        docsTitolare: [...(prevData.docsTitolare || []), ...newFiles], // Safely spread existing files or default to an empty array
      }));
      //validateFields({ docsTitolare: [...uploadedFilesTitolare, ...newFiles] });
      return;
    }

    // Gestione dei valori in base a nome del campo
    if (name === "dittaRadio") {
      setIsItalianResident(value === "italianResident");
      setFormData((prevData) => ({
        ...prevData,
        [name]: updatedValue,
        statoDitta: value === "italianResident" ? "IT" : prevData.statoDitta,
        localitaDitta: value === "extraResident" ? "" : prevData.localitaDitta, // Resetta localitaDitta solo per 'extraResident'
        provDitta: "", // Reset provDitta for extraResident
        comuneDitta: "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: updatedValue,
      }));
    }

    // Logica condizionale per altre opzioni
    if (name === "entityRadio") {

      setFormData((prevData) => ({
        ...prevData,
        [name]: updatedValue, // Update the radio button value
      }));

      setShowDittaRadio(value === "dittaIndividuale");
      setIsDittaIndividuale(value === "dittaIndividuale");

      if (value === "personaFisica") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: updatedValue, // Update the radio button value
          ragSociale: '',
          indirizzoDitta: '',
          numCivDitta: '',
          statoDitta: '',
          provDitta: '',
          comuneDitta: '',
          capDitta: '',
          localitaDitta: '',
          telefonoDitta: '',
          faxDitta: '',
          emailDitta: '',
          pIva: '',
          pecDitta: '',
          sdiCode: '',
        }));
        return;
      }
    }
  };
  const isAvantiEnabled =
    salesConditionArticleChecked &&
    salesConditionChecked &&
    allAccordionsOpen;

  // Funzione per rimuovere i file
  const fileInputRef = useRef(null);
  const fileInputRefTitolare = useRef(null);

  const removeFiles = () => {
    setUploadedFiles([]);

    setFormData((prevData) => ({
      ...prevData,
      docs: [],
    }));

    if (fileInputRef.current) {
      fileInputRef.current.value = "";  // This clears the input
    }

    //cancello gli errori
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.docs;
      return updatedErrors;
    });

  };


  const removeFilesTitolare = () => {
    setUploadedFilesTitolare([]);

    
    setFormData((prevData) => ({
      ...prevData,
      docsTitolare: [],
    }));

    if (fileInputRefTitolare.current) {
      fileInputRefTitolare.current.value = "";  // This clears the input
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.docsTitolare;
      return updatedErrors;
    });

  };

  // Funzioni aggiuntive per il drag-and-drop
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);

    setUploadedFiles((prevFiles) => [
      ...prevFiles,
      ...files,
    ]);

    // Update the formData for validation
    setFormData((prevFormData) => ({
      ...prevFormData,
      docs: [...(prevFormData.docs || []), ...files],
    }));
  };


  const handleDragOverTitolare = (e) => {
    e.preventDefault();
  };

  const handleDropTitolare = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    setUploadedFilesTitolare((prevFiles) => [
      ...prevFiles,
      ...files,
    ]);

    setFormData((prevFormData) => ({
      ...prevFormData,
      docsTitolare: [...(prevFormData.docsTitolare || []), ...files],
    }));

  };

  //ABILITA SEZIONE DOMICILIO
  const handleToggleChange = () => {
    setIsDomicileEnabled((prev) => !prev);

    if (isDomicileEnabled) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        indirizzoDom: '',
        numCivDom: '',
        statoDom: '',
        provDom: '',
        comuneDom: '',
        capDom: '',
        localitaDom: '',
      }));
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.indirizzoDom;
        delete newErrors.numCivDom;
        delete newErrors.statoDom;
        delete newErrors.provDom;
        delete newErrors.comuneDom;
        delete newErrors.capDom;
        delete newErrors.localitaDom;
        return newErrors;
      });
    }
  };
  const handleToggleTitolareChange = () => {
    setIsDomicileTitolareEnabled((prev) => !prev);

    if (isDomicileTitolareEnabled) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        indirizzoDomTitolare: '',
        numCivDomTitolare: '',
        statoDomTitolare: '',
        provDomTitolare: '',
        comuneDomTitolare: '',
        capDomTitolare: '',
        localitaDomTitolare: '',
      }));

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.indirizzoDomTitolare;
        delete newErrors.numCivDomTitolare;
        delete newErrors.statoDomTitolare;
        delete newErrors.provDomTitolare;
        delete newErrors.comuneDomTitolare;
        delete newErrors.capDomTitolare;
        delete newErrors.localitaDomTitolare;
        return newErrors;
      });

    }
  };


  // Funzione per gestire l'errore
  const validateFields = () => {
    const newErrors = {};
    let firstErrorField = null;
    const emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-]{2,})+\.)+([a-zA-Z0-9]{2,})+$/;
    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[0-9]{3}[0-9]{2,9}$/;
    const allowedFileTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "image/png", "image/jpeg"];
    const maxFileSize = 5 * 1024 * 1024;


    // Controllo generico per campi obbligatori e validazioni personalizzate
    Object.keys(formData).forEach((field) => {
      const value = formData[field] ?? ""; // Default to empty string if null or undefined
      const fieldElement = document.querySelector(`[name=${field}]`);
      let isValid = false;


      if (fieldElement) {
        if ((field.startsWith("email") || field.startsWith("pec"))) {
          if (value.trim() && !emailRegex.test(value)) {
            newErrors[field] = formData.nationality === "it" ? 'Formato email non valido' : "Invalid email format";
            if (!firstErrorField) firstErrorField = fieldElement;
          }
        }

        // Validate phone, celular, fax fields
        if (field.startsWith("telefono") || field.startsWith("cellulare") || field.startsWith("fax")) {
          if (value.trim() && !phoneRegex.test(value)) {
            newErrors[field] = formData.nationality === "it" ? 'Formato numero non valido' : "Invalid phone number format";
            if (!firstErrorField) firstErrorField = fieldElement;

          }
        }

        if (isConsentGiven) {
          const isAnyCheckboxChecked = Object.entries(formData)
            .filter(([key]) => key.startsWith('checkbox') && key !== 'checkboxTutti')
            .some(([_, value]) => value === true);

          if (!isAnyCheckboxChecked) {
            newErrors.checkboxes = formData.nationality === "it" ? 'Selezionare almeno un\'opzione' : "Select at least an option";
          } else {
            delete newErrors.checkboxes; // Clear error when a checkbox is selected
          }
        }


      }
      if (fieldElement && fieldElement.hasAttribute('required')) {

        if (Array.isArray(value)) {
          isValid = value.length > 0; // Valid if array has at least one file
        } else if (typeof value === 'string') {
          isValid = value.trim() !== ''; // Valid if non-empty string
        }


        if (!isValid) {

          if (!firstErrorField) {
            firstErrorField = fieldElement; // Set the first invalid field
          }

          if (field === 'docs' || field === 'docsTitolare') {
            newErrors[field] = formData.nationality === "it" ? 'Scegliere almeno un file' : "Choose at least one file";
          }
          else if (field === 'entityRadio') {
            newErrors[field] = formData.nationality === "it" ? 'Selezionare una delle due opzioni' : "Choose one of the two options";
          }
          else {
            if (field === 'nationality') {
              newErrors[field] = "Compilare il campo obbligatorio / Fill in the required field";
            }
            else {
              newErrors[field] = formData.nationality === "it" ? "Compilare il campo obbligatorio" : "Fill in the required field";
            }
          }
        } else {

          // Controllo codice fiscale
          function validateCodiceFiscale(field, value, formData, newErrors) {
            const isTitolare = field === 'codiceFiscaleTitolare';
            const countryIso = formData[`statoNascita${isTitolare ? 'Titolare' : ''}`];
            const countryResid = formData[`stato${isTitolare ? 'Titolare' : ''}`];
            // Saltare la validazione SOLO se la nazionalità è "en" e lo stato di nascita non è IT
            if (countryIso !== "IT" && countryResid !== "IT") {
              return;
            }

            if (value.length !== 16) {
              newErrors[field] = formData.nationality === "it" ? 'Il codice fiscale deve contenere esattamente 16 caratteri' : "Tax Code must contain exactly 16 characters";
              if (!firstErrorField) firstErrorField = fieldElement;
              return;
            }

            const codiceFiscaleRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z0-9]{4}[A-Z]$/i;
            if (!codiceFiscaleRegex.test(value)) {
              newErrors[field] = formData.nationality === "it" ? 'Errore nella formattazione del codice fiscale. Ricontrollare.' : "Wrong tax code format. Check again.";
              if (!firstErrorField) firstErrorField = fieldElement;
              return;
            }

            const codiceFiscaleComuneCodice = value.slice(11, 15); // Caratteri 12-15

            // Estrarre dati di nascita
            const dataNascita = new Date(formData[`dataNascita${isTitolare ? 'Titolare' : ''}`]);
            const birthYearLastTwoDigits = String(dataNascita.getFullYear()).slice(-2);
            const birthMonth = dataNascita.getMonth() + 1;
            const birthDay = dataNascita.getDate();

            // Estrarre anno e mese dal codice fiscale
            const codiceFiscaleYearDigits = value.slice(6, 8);
            if (codiceFiscaleYearDigits !== birthYearLastTwoDigits) {
              newErrors[field] = formData.nationality === "it" ? 'Codice Fiscale Errato. Ricontrollare.' : "Wrong tax code format. Check again.";
              if (!firstErrorField) firstErrorField = fieldElement;
            }

            // Validazione del mese
            const mesi = mesiNascita.mesiNascita;
            if (Array.isArray(mesi)) {
              const meseLetter = mesi.find(mese => mese.MESE === String(birthMonth))?.LETTERA;
              const codiceFiscaleMonthLetter = value.charAt(8).toUpperCase();
              if (meseLetter && codiceFiscaleMonthLetter !== meseLetter) {
                newErrors[field] = formData.nationality === "it" ? 'Codice Fiscale Errato. Ricontrollare.' : "Wrong tax code format. Check again.";
                if (!firstErrorField) firstErrorField = fieldElement;
              }
            } else {
              console.error("mesiNascita.mesiNascita is not an array", mesiNascita);
              newErrors[field] = 'Errore nel formato dei mesi di nascita. Contattare l\'assistenza.';
              if (!firstErrorField) firstErrorField = fieldElement;
            }

            // Validazione del giorno basato sul sesso
            const codiceFiscaleDayDigits = parseInt(value.slice(9, 11));
            const sesso = formData[`sesso${isTitolare ? 'Titolare' : ''}`];

            if (sesso === "Maschio" && codiceFiscaleDayDigits !== birthDay) {
              newErrors[field] = formData.nationality === "it" ? 'Codice Fiscale Errato. Ricontrollare.' : "Wrong tax code format. Check again.";
              if (!firstErrorField) firstErrorField = fieldElement;
            } else if (sesso === "Femmina" && codiceFiscaleDayDigits !== birthDay + 40) {
              newErrors[field] = formData.nationality === "it" ? 'Codice Fiscale Errato. Ricontrollare.' : "Wrong tax code format. Check again.";
              if (!firstErrorField) firstErrorField = fieldElement;
            }

            // Validazione codice comune/nazione
            if (countryIso === 'IT') {
              const selectedComune = comuniData.comuniItaliani.find(
                comune => comune.LOCALITA === formData[`comuneNascita${isTitolare ? 'Titolare' : ''}`]
              );
              const comuneCodice = selectedComune?.CODICE_COMUNALE;
              if (!comuneCodice || codiceFiscaleComuneCodice !== comuneCodice) {
                newErrors[field] = formData.nationality === "it" ? 'Codice Fiscale Errato. Ricontrollare.' : "Wrong tax code format. Check again.";
                if (!firstErrorField) firstErrorField = fieldElement;
              }
            } else {
              const countryCode = countries.find(c => c.iso === countryIso)?.codice;
              if (!countryCode || codiceFiscaleComuneCodice !== countryCode) {
                newErrors[field] = formData.nationality === "it" ? 'Codice Fiscale Errato. Ricontrollare.' : "Wrong tax code format. Check again.";
                if (!firstErrorField) firstErrorField = fieldElement;
              }
            }
          }

          // Chiamata alla funzione per entrambi i campi
          if (field === 'codiceFiscale' || field === 'codiceFiscaleTitolare') {
            validateCodiceFiscale(field, value, formData, newErrors);
          }

          

          if (page >= 3 && isDittaIndividuale) { // Esegui questa validazione solo dalla pagina 3 in avanti
            const sdiCodeComplete =
              Array.isArray(valuesSDI) &&
              valuesSDI.length === 7 &&
              valuesSDI.every((char) => char.trim() !== '');

            const pecValid = formData.pecDitta && emailRegex.test(formData.pecDitta.trim());

            if (formData.dittaRadio !== "extraResident") {
              if (!sdiCodeComplete && !pecValid) {
                newErrors.sdiOrPec = "Inserisci un Codice SDI completo (7 caratteri) oppure un indirizzo PEC valido.";
              }

              if (formData.pIva.length !== 11 && formData.pIva.length !== 13) {
                newErrors.pIva = formData.nationality === "it" ? 'La Partita IVA deve essere lunga 11 o 13 caratteri.' : "Italian Vat Code must be long 11 or 13 characters ";
              }
            }
            
          }
          const validateLocationForState = (stateField, locationField, errorField) => {
            if (formData[stateField] !== "IT" && (!formData[locationField]?.trim())) {
              // Determine the context (Residenza, Nascita, Domicilio) based on errorField

              if (stateField === "statoDitta") {
                newErrors[errorField] = formData.nationality === "it"
                  ? "La Località è obbligatoria per stati diversi da IT."
                  : "Location is required for countries other than Italy.";
                return;
              }


              const context = errorField.includes("Resid")
                ? "Residenza"
                : errorField.includes("Nascita")
                  ? "Nascita"
                  : errorField.includes("Dom")
                    ? "Domicilio"
                    : "";

              if (formData.nationality == "it") {

              }

              if (context) {
                if (formData.nationality === "it") {
                  newErrors[errorField] = `Luogo di ${context} è obbligatorio per stati diversi da IT.`;
                } else {
                  // Translate the message for non-Italian nationality
                  const translationContext = context === "Residenza" ? "Residence" :
                    context === "Nascita" ? "Birth" :
                      context === "Domicilio" ? "Domicile" : "";

                  newErrors[errorField] = `Place of ${translationContext} is required for countries other than Italy.`;
                }
              }
            }
          };


          // Apply validation based on the field
          switch (field) {
            case "stato":
              validateLocationForState("stato", "localitaResid", "localitaResid");
              break;
            case "statoDom":
              validateLocationForState("statoDom", "localitaDom", "localitaDom");
              break;
            case "statoDitta":
              validateLocationForState("statoDitta", "localitaDitta", "localitaDitta");
              break;
            case "statoTitolare":
              validateLocationForState("statoTitolare", "localitaResidTitolare", "localitaResidTitolare");
              break;
            case "statoDomTitolare":
              validateLocationForState("statoDomTitolare", "localitaDomTitolare", "localitaDomTitolare");
              break;
            case "statoNascita":
              validateLocationForState("statoNascita", "luogoNascita", "luogoNascita");
              break;
            case "statoNascitaTitolare":
              validateLocationForState("statoNascitaTitolare", "luogoNascitaTitolare", "luogoNascitaTitolare");
              break;
            default:
              break;
          }

         

          if (field === 'docs') {
            const files = Array.isArray(formData.docs) ? formData.docs : [];

            let fieldErrors = [];  // To accumulate errors for the field

            if (files.length > 4) {
              fieldErrors.push(formData.nationality === "it"
                ? "Puoi caricare massimo 4 file"
                : "You can upload at max 4 files");
            } else {
              files.forEach((file) => {
                if (!allowedFileTypes.includes(file.type)) {
                  fieldErrors.push(
                    formData.nationality === "it"
                      ? "Formato file non valido. Consentiti: PDF, DOC, PNG, JPG."
                      : "Invalid file format. Allowed: PDF, DOC, PNG, JPG."
                  );
                }
                if (file.size > maxFileSize) {
                  fieldErrors.push(formData.nationality === "it"
                    ? `Il file ${file.name} supera la dimensione massima di 5MB.`
                    : `The file ${file.name} exceeds the maximum size of 5MB.`);
                }
              });
            }

            if (fieldErrors.length > 0) {
              newErrors[field] = fieldErrors.join(" ");  // Combine errors into a single string
              if (!firstErrorField) firstErrorField = fieldElement;
            } else {
              delete newErrors[field];  // Remove any existing errors for this field if valid
            }
          }

          // Validate docsTitolare field
          if (field === 'docsTitolare') {
            const files = Array.isArray(formData.docsTitolare) ? formData.docsTitolare : [];

            let fieldErrors = [];  // To accumulate errors for the field

            if (files.length > 4) {
              fieldErrors.push(formData.nationality === "it"
                ? "Puoi caricare massimo 4 file"
                : "You can upload at max 4 files")
            } else {
              files.forEach((file) => {
                if (!allowedFileTypes.includes(file.type)) {
                  fieldErrors.push(
                    formData.nationality === "it"
                      ? "Formato file non valido. Consentiti: PDF, DOC, PNG, JPG."
                      : "Invalid file format. Allowed: PDF, DOC, PNG, JPG."
                  );
                }
                if (file.size > maxFileSize) {
                  fieldErrors.push(formData.nationality === "it"
                    ? `Il file ${file.name} supera la dimensione massima di 5MB.`
                    : `The file ${file.name} exceeds the maximum size of 5MB.`);
                }
              });
            }

            if (fieldErrors.length > 0) {
              newErrors[field] = fieldErrors.join(" ");  // Combine errors into a single string
              if (!firstErrorField) firstErrorField = fieldElement;
            } else {
              delete newErrors[field];  // Remove any existing errors for this field if valid
            }
          }

          if ((field === 'dataNascita' && new Date(formData[field]) > today) || (field === 'dataNascitaTitolare' && new Date(formData[field]) > today)) {
            newErrors[field] = formData.nationality === "it" ? "Inserisci una data di nascita valida." : "Enter a valid date of birth.";
            if (!firstErrorField) firstErrorField = fieldElement;

          }
          // Controllo PEP
          if (field === 'pepText' && isPepSelected && value && value.length < 10) {
            newErrors[field] = formData.nationality === "it" ? "Il testo deve essere almeno di 10 caratteri" : "The text must be at least 10 characters long.";
            if (!firstErrorField) firstErrorField = fieldElement;

          }

          if (field === 'dataDoc' || field === 'dataScadDoc') {
            const dataDoc = new Date(formData.dataDoc || null);
            const dataScadDoc = new Date(formData.dataScadDoc || null);

            if (field === 'dataDoc' && dataDoc > today) {
              newErrors[field] = formData.nationality === "it" ? "La data di rilascio non può essere successiva alla data di oggi" : "The issue date cannot be later than today's date.";
              if (!firstErrorField) firstErrorField = fieldElement;
            }

            if (field === 'dataScadDoc') {
              if (dataScadDoc <= dataDoc) {
                newErrors[field] = formData.nationality === "it" ? "La data di scadenza deve essere successiva alla data di rilascio" : "The expiration date must be later than the issue date.";
                if (!firstErrorField) firstErrorField = fieldElement;

              } else if (dataScadDoc < today) {
                newErrors[field] = formData.nationality === "it" ? "La data di scadenza non può essere precedente alla data di oggi" : "The expiration date cannot be earlier than today's date.";
                if (!firstErrorField) firstErrorField = fieldElement;
              }
            }
          }

          // Validation for 'dataDocTitolare' and 'dataScadDocTitolare'
          if (field === 'dataDocTitolare' || field === 'dataScadDocTitolare') {
            const dataDocTitolare = new Date(formData.dataDocTitolare || null);
            const dataScadDocTitolare = new Date(formData.dataScadDocTitolare || null);

            if (field === 'dataDocTitolare' && dataDocTitolare > today) {
              newErrors[field] = formData.nationality === "it" ? "La data di rilascio non può essere successiva alla data di oggi" : "The issue date cannot be later than today's date.";
              if (!firstErrorField) firstErrorField = fieldElement;

            }

            if (field === 'dataScadDocTitolare') {
              if (dataScadDocTitolare <= dataDocTitolare) {
                newErrors[field] = formData.nationality === "it" ? "La data di scadenza deve essere successiva alla data di rilascio" : "The expiration date must be later than the issue date.";
                if (!firstErrorField) firstErrorField = fieldElement;

              } else if (dataScadDocTitolare < today) {
                newErrors[field] = formData.nationality === "it" ? "La data di scadenza non può essere precedente alla data di oggi" : "The expiration date cannot be earlier than today's date.";
                if (!firstErrorField) firstErrorField = fieldElement;

              }
            }
          }

          if (field === 'entityRadio' && formData.entityRadio === "dittaIndividuale" && !formData.dittaRadio) {
            newErrors.dittaRadio = "Seleziona una delle due opzioni";
          }



        }
      }



    });




    if (firstErrorField) {
      //console.log("Focusing on first error field:", firstErrorField);
      firstErrorField.focus();
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;


  };




  useEffect(() => {
    if (formData.consensoA === '') {
      setIsConsentDenied(true);
    }
  }, [formData.consensoA]);



  // Funzione per andare alla pagina successiva
  const nextPage = () => {
    if (!validateFields()) {
      //console.log("Remaining Errors:", errors);
      return;
    }
    //console.log("Remaining Errors:", errors);

    const transitions = {
      1: 2,
      2: 3,
      3: 4,
      4: 5,
      5: 6,
      6: 7,
      7: 8,
      8: isTitolareSelected ? 9 : 9,
      9: 10,
      10: 11,
    };

    const next = transitions[page];


    if (next <= totalPages) {
      setPage(next);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const prevPage = () => {
    if (page > 1) {
      if (page === 4 && !isDittaIndividuale) {
        setPage(2); // Special case for page 4
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        setPage((prev) => Math.max(prev - 1, 1));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

  };



  const getPageSubtitle = (page, nationality, entityRadio) => {
    switch (page) {
      case 2:
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Anagrafica Personale" : "Natural Person - Personal Data";
        }
        else if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Anagrafica Personale" : "Individual Company - Personal Data";
        }
        break;
      case 3:
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Anagrafica della Ditta" : "Individual Company - Company Data";
        }
      case 4:
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Informativa Privacy" : "Natural Person - Privacy Policy";
        }
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Informativa Privacy" : "Individual Company - Privacy Policy";
        }
      case 5:
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Condizioni di Vendita" : "Natural Person - Terms of Sale";
        }
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Condizioni di Vendita" : "Individual Company - Terms of Sale";
        }
      case 6:
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Informativa Antiriciclaggio (1 di 2)" : "Natural Person - Anti-Money Laundering Policy (1 of 2)";
        }
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Informativa Antiriciclaggio (1 di 2)" : "Individual Company - Anti-Money Laundering Policy (1 of 2)";
        }
      case 7:
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Informativa Antiriciclaggio (2 di 2)" : "Natural Person - Anti-Money Laundering Policy (2 of 2)";
        }
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Informativa Antiriciclaggio (2 di 2)" : "Individual Company - Anti-Money Laundering Policy (2 of 2)";
        }
      case 8:
        if (entityRadio === "personaFisica" && isTitolareSelected) {
          return nationality === "it" ? "Persona Fisica - Anagrafica del Titolare Effettivo" : "Natural Person - Beneficial Owner's Data";
        }
        if (entityRadio === "dittaIndividuale" && isTitolareSelected) {
          return nationality === "it" ? "Ditta Individuale - Anagrafica del Titolare Effettivo" : "Individual Company - Beneficial Owner's Data";
        }
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Dichiarazione dello Scopo della Prestazione" : "Natural Person - Declaration of the Purpose of the Transaction";
        }
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Dichiarazione dello Scopo della Prestazione" : "Individual Company - Declaration of the Purpose of the Transaction";
        }
      case 9:
        if (entityRadio === "personaFisica" && isTitolareSelected) {
          return nationality === "it" ? "Persona Fisica - Dichiarazione dello Scopo della Prestazione" : "Natural Person - Declaration of the Purpose of the Transaction";
        }
        if (entityRadio === "dittaIndividuale" && isTitolareSelected) {
          return nationality === "it" ? "Ditta Individuale - Dichiarazione dello Scopo della Prestazione" : "Individual Company - Declaration of the Purpose of the Transaction";
        }
        if (entityRadio === "personaFisica") {
          return nationality === "it" ? "Persona Fisica - Codice di Autenticazione" : "Natural Person - Authentication Code";
        }
        if (entityRadio === "dittaIndividuale") {
          return nationality === "it" ? "Ditta Individuale - Codice di Autenticazione" : "Individual Company - Authentication Code";
        }
      case 10:
        if (entityRadio === "personaFisica" && isTitolareSelected) {
          return nationality === "it" ? "Persona Fisica - Codice di Autenticazione" : "Natural Person - Authentication Code";
        }
        if (entityRadio === "dittaIndividuale" && isTitolareSelected) {
          return nationality === "it" ? "Ditta Individuale - Codice di Autenticazione" : "Individual Company - Authentication Code";
        }
      default:
        return ""; // Default empty string if no match
    }
  };

  useEffect(() => {
    if (formData.statoDitta === "SSL") {
      const errorMessage = formData.nationality === "it"
        ? "Compilare il campo obbligatorio"
        : "Fill in the required field";
      
      errors.statoDitta = errorMessage;
    }
  }, [formData.statoDitta, formData.nationality]);

  let totalPages = isTitolareSelected ? 11 : 10;
  const progress = Math.min(((page - 1) / (totalPages - 1)) * 100, 100);

  return (
    <div className="flex justify-center items-center min-h-screen-custom bg-gray-100">

      <form
        onSubmit={handleSubmit}
        className="w-full max-w-5xl bg-white rounded-lg shadow-md relative"

      >

        {/* Barra di progresso */}

        <div className="header flex flex-wrap items-center justify-between px-4 sm:px-10 py-3 sm:py-5">
          {/* Left-aligned text */}
          <div className="text-left">
            <h1 className="text-[rgb(123,28,62)] text-lg sm:text-2xl font-bold">Meeting Art</h1>
            <h2 className="text-gray-500 text-sm sm:text-lg">Casa d'Aste S.p.A.</h2>
          </div>

          {/* Logo on the right */}
          <img
            src="/images/logo_MEETINGART.png"
            alt="Meeting Art Logo"
            className="h-12 sm:h-16 ml-[-30px] sm:ml-[-40px]"
          />

          {/* Language Selector Button */}
          {/* Italian Flag (when nationality is "it") */}
          {formData.nationality === "it" && (
            <button
              className="flex items-center gap-x-2 px-2 sm:px-3 py-1 text-gray-500 rounded-md cursor-not-allowed"
              disabled
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 3 2"
                className="w-5 sm:w-6 h-3 sm:h-4"
              >
                <rect width="3" height="2" fill="#009246" />
                <rect width="2" height="2" x="1" fill="#fff" />
                <rect width="1" height="2" x="2" fill="#ce2b37" />
              </svg>
              <span className="text-xs sm:text-sm font-semibold">IT</span>
            </button>
          )}

          {/* English Flag (when nationality is "en") */}
          {formData.nationality === "en" && (
            <button
              className="flex items-center gap-x-2 px-2 sm:px-3 py-1 text-gray-500 rounded-md cursor-not-allowed"
              disabled
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 5 3"
                className="w-5 sm:w-6 h-3 sm:h-4"
              >
                <rect width="5" height="3" fill="#012169" />
                <path stroke="#fff" strokeWidth="0.6" d="M0,0 L5,3 M5,0 L0,3" />
                <path stroke="#C8102E" strokeWidth="0.4" d="M0,0 L5,3 M5,0 L0,3" />
                <path fill="#fff" d="M2,0 h1 v3 h-1 z M0,1 h5 v1 h-5 z" />
                <path fill="#C8102E" d="M2.2,0 h0.6 v3 h-0.6 z M0,1.2 h5 v0.6 h-5 z" />
              </svg>
              <span className="text-xs sm:text-sm font-semibold">EN</span>
            </button>
          )}

        </div>




        <div className="p-8">
          {page === 1 && formData.nationality === "" && (
            <h2 className="text-center mt-5 text-2xl font-bold mb-6">
              Form di Registrazione per Persone Fisiche/ Professionisti e Ditte Individuali
            </h2>
          )}
          <h2 className="text-center mt-5 text-2xl font-bold">{staticText[formData.nationality]?.form} </h2>
          {page > 1 && (
            <p className="text-center mt-2 text-md  mb-6 italic" style={{ color: "rgb(199 48 102)" }}>
              {getPageSubtitle(page, formData.nationality, formData.entityRadio)}
            </p>)}
          <div className="w-full h-4 bg-gray-300 rounded-full mb-6">
            <div
              className="h-full rounded-full flex items-center justify-center"
              style={{
                width: `${progress}%`,
                transition: 'width 0.5s ease-in-out',
                backgroundColor: '#7B1C3E', // Set the color to #7B1C3E
              }}
            >
              {page !== 1 && (
                <span className="text-white font-bold text-sm">
                  {Math.round(progress)}%
                </span>
              )}
            </div>
          </div>


          {page === 1 && (
            <>
              <h3 className="text-center text-2xl font-bold ">Di che nazionalità sei?</h3>
              <h4 className="text-center text-2xl font-light text-gray-600 italic translate-y-1 mb-6">What is your nationality?</h4>
              <div className="flex flex-col space-y-4 items-center">

                <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-5 mt-5 text-lg">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="italiana"
                      name="nationality"
                      value="it"
                      checked={formData.nationality === "it"}
                      required
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      onChange={handleInputChange}
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white"
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label htmlFor="italiana" className="ml-2 text-gray-700 cursor-pointer">
                      Italiana / <span className="italic">Italian</span>
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="estera"
                      name="nationality"
                      value="en"
                      checked={formData.nationality === "en"}
                      required
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      onChange={handleInputChange}
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white"
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label htmlFor="estera" className="ml-2 text-gray-700 cursor-pointer">
                      Estera / <span className="italic">Foreign</span>
                    </label>
                  </div>
                </div>
                {errors.nationality && (
                  <span className="text-red-600 text-sm">{errors.nationality}</span>
                )}
              </div>
              {formData.nationality && (
                <div className="flex flex-col items-center transition-opacity duration-500 opacity-1">
                  <h3 className="mt-10 text-center text-2xl font-bold mb-6">
                    {staticText[formData.nationality]?.entita}
                  </h3>
                  <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-5 mt-5 text-lg">

                    {/* Wrapper to align radio buttons side by side */}
                    {/* Persona Fisica */}
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="personaFisica"
                        name="entityRadio"
                        value="personaFisica"
                        checked={formData.entityRadio === "personaFisica"}
                        required
                        className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                        onChange={handleInputChange}
                      />
                      <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-white"
                          viewBox="-2 0 19 19"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                      <label htmlFor="personaFisica" className="ml-2 text-gray-700 cursor-pointer">
                        {staticText[formData.nationality]?.persona}
                      </label>
                    </div>

                    {/* Ditta Individuale */}
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="dittaIndividuale"
                        name="entityRadio"
                        value="dittaIndividuale"
                        checked={formData.entityRadio === "dittaIndividuale"}
                        required
                        className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                        onChange={handleInputChange}
                      />
                      <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-white"
                          viewBox="-2 0 19 19"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                      <label htmlFor="dittaIndividuale" className="ml-2 text-gray-700 cursor-pointer">
                        {staticText[formData.nationality]?.ditta}
                      </label>
                    </div>
                  </div>
                  {errors.entityRadio && (
                    <span className="text-red-600 text-sm">{errors.entityRadio}</span>
                  )}
                </div>

              )}




              {showDittaRadio && (

                <div className="flex flex-col space-y-4 items-center transition-opacity duration-500 opacity-1">
                  <h3 className="mt-10 text-center text-2xl font-bold mb-6">
                    {staticText[formData.nationality]?.italianResidence}
                  </h3>
                  <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-5 mt-5 text-lg">
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="italianResident"
                        name="dittaRadio"
                        value="italianResident"
                        checked={formData.dittaRadio === "italianResident"} // Check based on formData
                        required
                        className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                        onChange={handleInputChange}
                      />
                      <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                          viewBox="-2 0 19 19"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                      <label className="ml-2 text-gray-700 cursor-pointer">{staticText[formData.nationality]?.yes}</label>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="extraResident"
                        name="dittaRadio"
                        value="extraResident"
                        checked={formData.dittaRadio === "extraResident"} // Check based on formData
                        required
                        className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                        onChange={handleInputChange}
                      />
                      <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                          viewBox="-2 0 19 19"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                      <label className="ml-2 text-gray-700 cursor-pointer">No</label>
                    </div>
                  </div>

                  {errors.dittaRadio && (
                    <span className="text-red-600 text-sm">{errors.dittaRadio}</span>
                  )}
                </div>
              )}

            </>
          )}

          {page === 2 && (
            <>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                {/* Nome Field */}
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.cognome} (*)</label>
                  <input
                    type="text"
                    value={formData.cognome}
                    name="cognome"
                    onChange={handleInputChange}
                    required
                    maxLength={100}
                    placeholder={staticText[formData.nationality]?.insertCognome}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.cognome && <span className="text-red-600 text-sm">{errors.cognome}</span>}
                </div>

                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.nome} (*)</label>
                  <input
                    type="text"
                    value={formData.nome}
                    name="nome"
                    onChange={handleInputChange}
                    required
                    maxLength={100}
                    placeholder={staticText[formData.nationality]?.insertNome}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.nome && <span className="text-red-600 text-sm">{errors.nome}</span>}
                </div>
                {/* Sesso Field (Dropdown) */}
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.sesso} (*)</label>
                  <select
                    value={formData.sesso}
                    name="sesso"
                    onChange={handleInputChange}
                    required
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled> {formData.nationality === "it" ? 'Seleziona il tuo genere' : "Select your gender"}</option>
                    <option value="Maschio"> {formData.nationality === "it" ? 'Maschio' : "Male"}</option>
                    <option value="Femmina"> {formData.nationality === "it" ? 'Femmina' : "Female"}</option>
                  </select>
                  {errors.sesso && <span className="text-red-600 text-sm">{errors.sesso}</span>}
                </div>
              </div>


              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-2">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.indirizzo} (*)</label>
                  <input
                    type="text"
                    value={formData.indirizzo}
                    name="indirizzo"
                    onChange={handleInputChange}
                    required
                    maxLength={80}
                    placeholder={staticText[formData.nationality]?.insertIndirizzo}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.indirizzo && <span className="text-red-600 text-sm">{errors.indirizzo}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.numCiv}</label>
                  <input
                    type="text"
                    value={formData.numCiv}
                    name="numCiv"
                    maxLength={10}
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertNumeroCivico}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.numCiv && <span className="text-red-600 text-sm">{errors.numCiv}</span>}
                </div>

              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.country} (*)</label>
                  <select
                    value={formData.stato}
                    name="stato"
                    onChange={handleCountryChange}
                    required
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaStato}</option>
                    {countries
                      .sort((a, b) => {
                        const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                        const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                        return nameA.localeCompare(nameB); // Sort alphabetically by the selected name
                      })
                      .filter(country => country.iso !== 'YU')
                      .map((country) => (
                        <option key={country.iso} value={country.iso}>
                          {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                        </option>
                      ))}
                  </select>
                  {errors.stato && <span className="text-red-600 text-sm">{errors.stato}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.prov} (*)</label>
                  <select
                    value={formData.provincia}
                    name="provincia"
                    onChange={handleProvinciaChange}
                    required={isItaly}
                    disabled={!isItaly}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                    {provinceItaliane.map((provincia) => (
                      <option key={provincia.sigla} value={provincia.sigla}>
                        {provincia.nome} ({provincia.sigla})
                      </option>
                    ))}
                  </select>
                  {errors.provincia && <span className="text-red-600 text-sm">{errors.provincia}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.comune} (*)</label>
                  <select
                    value={formData.comuneResid}
                    name="comuneResid"
                    onChange={handleComuneChange}
                    required={isItaly && formData.provincia !== ''}
                    disabled={!isItaly && formData.provincia === ''}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                    {filteredComuniRes.map((comune) => (
                      <option key={comune.LOCALITA} value={comune.LOCALITA}>
                        {comune.LOCALITA}
                      </option>
                    ))}
                  </select>
                  {errors.comuneResid && <span className="text-red-600 text-sm">{errors.comuneResid}</span>}
                </div>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">

                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.cap} (*)</label>
                  <input
                    type="text"
                    value={formData.cap}
                    name="cap"
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                    placeholder={staticText[formData.nationality]?.insertCAP}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    disabled={
                      !!formData.comuneResid &&
                      filteredComuniRes.some(
                        (comune) => comune.LOCALITA === formData.comuneResid && comune.CAP
                      )
                    }
                  />
                  {errors.cap && <span className="text-red-600 text-sm">{errors.cap}</span>}
                </div>

                <div className="col-span-2">
                  <label className="block text-gray-700">  {staticText[formData.nationality]?.luogoResid} {!isItaly && <span>(*)</span>}
                  </label>
                  <input
                    type="text"
                    value={formData.localitaResid}
                    name="localitaResid"
                    onChange={handleInputChange}
                    maxLength={80}
                    disabled={isItaly}
                    placeholder={staticText[formData.nationality]?.insertLocalitaResidenza}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.localitaResid && <span className="text-red-600 text-sm">{errors.localitaResid}</span>}
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.tel}</label>
                  <input
                    type="tel"
                    value={formData.telefono}
                    name="telefono"
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertNumeroTelefono}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.telefono && <span className="text-red-600 text-sm">{errors.telefono}</span>}
                </div>
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.cell} (*)</label>
                  <input
                    type="tel"
                    value={formData.cellulare}
                    name="cellulare"
                    onChange={handleInputChange}
                    required
                    placeholder={staticText[formData.nationality]?.insertNumeroCellulare}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.cellulare && <span className="text-red-600 text-sm">{errors.cellulare}</span>}
                </div>
                <div>
                  <label className="block text-gray-700">Fax</label>
                  <input
                    type="tel"
                    value={formData.fax}
                    name="fax"
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertFax}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.fax && <span className="text-red-600 text-sm">{errors.fax}</span>}
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700">Email (*)</label>
                  <input
                    type="text"
                    value={formData.email}
                    name="email"
                    onChange={handleInputChange}
                    required
                    placeholder={staticText[formData.nationality]?.insertEmail}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.email && <span className="text-red-600 text-sm">{errors.email}</span>}
                </div>
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.pec}</label>
                  <input
                    type="text"
                    value={formData.pec}
                    name="pec"
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertPEC}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.pec && <span className="text-red-600 text-sm">{errors.pec}</span>}
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.dataNascita} (*)</label>
                  <input
                    type="date"
                    value={formData.dataNascita}
                    name="dataNascita"
                    onChange={handleInputChange}
                    required
                    max={formattedDate}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.dataNascita && <span className="text-red-600 text-sm">{errors.dataNascita}</span>}

                </div>

                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.countryNascita} (*)</label>
                  <select
                    value={formData.statoNascita}
                    name="statoNascita"
                    onChange={handleCountryNascitaChange}
                    required
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaStato}</option>
                    {countries
                      .sort((a, b) => {
                        const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                        const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                        return nameA.localeCompare(nameB); // Sort alphabetically by the selected name
                      })
                      .map((country) => (
                        <option key={country.iso} value={country.iso}>
                          {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                        </option>
                      ))}
                  </select>
                  {errors.statoNascita && <span className="text-red-600 text-sm">{errors.statoNascita}</span>}
                </div>


                <div >
                  <label className="block text-gray-700">{staticText[formData.nationality]?.provNascita} (*)</label>
                  <select
                    value={formData.provinciaNascita}
                    name="provinciaNascita"
                    onChange={handleProvinciaNascitaChange}
                    required={isItalyNascita}
                    disabled={!isItalyNascita}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                    {provinceItaliane.map((provincia) => (
                      <option key={provincia.sigla} value={provincia.sigla}>
                        {provincia.nome} ({provincia.sigla})
                      </option>
                    ))}
                  </select>
                  {errors.provinciaNascita && <span className="text-red-600 text-sm">{errors.provinciaNascita}</span>}
                </div>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.comuneNascita} (*)</label>
                  <select
                    value={formData.comuneNascita}
                    name="comuneNascita"
                    onChange={handleInputChange}
                    required={isItalyNascita}
                    disabled={!isItalyNascita || !formData.provinciaNascita}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                    {filteredComuni.map((comune) => (
                      <option key={comune.CODICE_COMUNALE} value={comune.LOCALITA}>
                        {comune.LOCALITA}
                      </option>
                    ))}
                  </select>
                  {errors.comuneNascita && <span className="text-red-600 text-sm">{errors.comuneNascita}</span>}
                </div>
                <div className="col-span-2">
                  <label className="block text-gray-700">  {staticText[formData.nationality]?.luogoNascita}  {!isItalyNascita && <span>(*)</span>}
                  </label>
                  <input
                    type="text"
                    value={formData.luogoNascita}
                    name="luogoNascita"
                    onChange={handleInputChange}
                    disabled={isItalyNascita}
                    placeholder={staticText[formData.nationality]?.insertLocalitaNascita}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.luogoNascita && <span className="text-red-600 text-sm">{errors.luogoNascita}</span>}
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4">
                <div className="mb-4">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.codFiscale}
                    {(formData.nationality === "en" && (formData.stato === "IT" || formData.statoNascita === "IT")) && (
                      " (*) (Format XXXYYY00A00ZZZZW) "
                    )}
                    {(formData.nationality === "it" && (formData.stato === "IT" || formData.statoNascita === "IT")) && (
                      " (*) (Formato XXXYYY00A00ZZZZW) "
                    )}
                  </label>
                  <input
                    type="text"
                    value={formData.codiceFiscale}
                    name="codiceFiscale"
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertCodiceFiscale}
                    maxLength={30}
                    required={isCodFiscaleRequired}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    key={formData.nationality + formData.statoNascita} // This forces React to re-render when the condition changes

                  />
                  {errors.codiceFiscale && <span className="text-red-600 text-sm">{errors.codiceFiscale}</span>}
                </div>
              </div>



              <div className="mb-4 mt-10">
                <p><span
                  dangerouslySetInnerHTML={{
                    __html: staticText[formData.nationality]?.identityParagraph || ''
                  }}
                /></p>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.tipoDoc} (*)</label>
                  <select
                    value={formData.tipoDoc}
                    name="tipoDoc"
                    onChange={handleInputChange}
                    required
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>
                      {formData.nationality === "it" ? 'Seleziona il tipo di documento' : "Select the document type"}
                    </option>
                    <option value="CARTA D'IDENTITÀ">  {formData.nationality === "it" ? 'CARTA D\'IDENTITÀ' : "IDENTITY DOCUMENT"}</option>
                    <option value="PASSAPORTO">  {formData.nationality === "it" ? 'PASSAPORTO' : "PASSPORT"} </option>
                    <option value="PATENTE DI GUIDA">  {formData.nationality === "it" ? 'PATENTE DI GUIDA' : "DRIVER'S LICENSE"}</option>
                  </select>
                  {errors.tipoDoc && <span className="text-red-600 text-sm">{errors.tipoDoc}</span>}
                </div>
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.numDoc} (*)</label>
                  <input
                    type="text"
                    value={formData.numDoc}
                    name="numDoc"
                    onChange={handleInputChange}
                    required
                    maxLength={20}
                    placeholder={staticText[formData.nationality]?.insertNumeroDocumento}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.numDoc && <span className="text-red-600 text-sm">{errors.numDoc}</span>}

                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.dataDoc} (*)</label>
                  <input
                    type="date"
                    value={formData.dataDoc}
                    name="dataDoc"
                    onChange={handleInputChange}
                    required
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.dataDoc && <span className="text-red-600 text-sm">{errors.dataDoc}</span>}
                </div>
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.dataScadDoc} (*)</label>
                  <input
                    type="date"
                    value={formData.dataScadDoc}
                    name="dataScadDoc"
                    onChange={handleInputChange}
                    required
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.dataScadDoc && <span className="text-red-600 text-sm">{errors.dataScadDoc}</span>}
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700">{staticText[formData.nationality]?.rilascioDoc} (*)</label>
                <input
                  type="text"
                  value={formData.rilascioDoc}
                  name="rilascioDoc"
                  onChange={handleInputChange}
                  required
                  maxLength={100}
                  placeholder={staticText[formData.nationality]?.insertEnteRilascioDocumento}
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                />
                {errors.rilascioDoc && <span className="text-red-600 text-sm">{errors.rilascioDoc}</span>}

              </div>

              <label className="mb-5 mt-5 block text-gray-700"> <span
                dangerouslySetInnerHTML={{
                  __html: staticText[formData.nationality]?.docParagraph || ''
                }}
              /></label>
              <div
                className="mb-4 w-full py-9 bg-gray-50 rounded-2xl border border-gray-300 gap-3 grid border-dashed"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <div className="grid gap-1">
                  <h2 className="text-center text-gray-400 text-xs leading-4">
                    {staticText[formData.nationality]?.format}
                  </h2>
                </div>
                <div className="grid gap-2">
                  <h4 className="text-center text-gray-900 text-sm font-medium leading-snug">
                    {staticText[formData.nationality]?.drag}
                  </h4>
                  <div className="flex items-center justify-center">
                    <label>
                      <input
                        type="file"
                        hidden
                        name="docs"
                        multiple
                        onChange={handleInputChange}
                        ref={fileInputRef}
                        required
                      />
                      <div className="flex w-28 h-9 px-2 flex-col primary-color rounded-full shadow text-white text-xs font-semibold leading-4 items-center justify-center cursor-pointer focus:outline-none">
                        {staticText[formData.nationality]?.chooseDocs}
                      </div>
                    </label>

                    {/* Pulsante "Cancella i file" visibile se ci sono file caricati */}
                    {uploadedFiles.length > 0 && (
                      <button
                        type="button"
                        className="ml-4 bg-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm font-medium"
                        onClick={removeFiles}
                      >
                        {staticText[formData.nationality]?.removeDocs}
                      </button>
                    )}
                  </div>

                  {/* Visualizza i file caricati */}
                  {uploadedFiles.length > 0 && (
                    <ul className="text-center text-gray-900 text-sm mt-4">
                      {uploadedFiles.map((file, index) => (
                        <li key={index} className="font-semibold">
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  )}

                  {/* Visualizza errori */}
                  {errors.docs && (
                    <span className="text-red-600 text-center text-sm">{errors.docs}</span>
                  )}
                </div>
              </div>



            </>
          )}
          {isDittaIndividuale && page === 3 && ( // Show third page only if checkbox is checked
            <>
              <div className="mb-4">
                <label className="block text-gray-700">{staticText[formData.nationality]?.ragSociale} (*)</label>
                <input
                  type="text"
                  value={formData.ragSociale}
                  name="ragSociale"
                  onChange={handleInputChange}
                  required
                  maxLength={80}
                  placeholder={staticText[formData.nationality]?.insertRagSoc}
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                />
                {errors.ragSociale && <span className="text-red-600 text-sm">{errors.ragSociale}</span>}
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-2">
                  <label className="block text-gray-700">{formData.nationality === "it" ? "Indirizzo" : "Address"} (*)</label>
                  <input
                    type="text"
                    value={formData.indirizzoDitta}
                    name="indirizzoDitta"
                    onChange={handleInputChange}
                    required
                    maxLength={80}
                    placeholder={staticText[formData.nationality]?.insertIndirizzo}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.indirizzoDitta && <span className="text-red-600 text-sm">{errors.indirizzoDitta}</span>}

                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.numCiv}</label>
                  <input
                    type="text"
                    value={formData.numCivDitta}
                    name="numCivDitta"
                    maxLength={10}
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertNumeroCivico}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.numCivDitta && <span className="text-red-600 text-sm">{errors.numCivDitta}</span>}
                </div>

              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
              <div className="col-span-1">
                <label className="block text-gray-700">
                  {staticText[formData.nationality]?.country}(*)
                </label>
                <select
                  value={formData.statoDitta || ""} // If no country is selected, default to an empty string
                  name="statoDitta"
                  onChange={handleCountryDittaChange}
                  required
                  disabled={isItalianResident} // Disables the select if the user is an Italian resident
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                >
                  {/* Default option with text 'Seleziona Stato' */}
                  <option value="SSL" disabled={isItalianResident}>
                    {staticText[formData.nationality]?.selezionaStato}
                  </option>
                  {countries
                    .filter(country => (isItalianResident || country.iso !== 'IT') && country.iso !== 'YU') // Filter countries based on isItalianResident
                    .sort((a, b) => {
                      const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                      const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                      return nameA.localeCompare(nameB); // Sort countries alphabetically
                    })
                    .map((country) => (
                      <option key={country.iso} value={country.iso}>
                        {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                      </option>
                    ))}
                </select>
                {errors.statoDitta && <span className="text-red-600 text-sm">{errors.statoDitta}</span>}
              </div>

                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.prov} (*)</label>
                  <select
                    value={formData.provDitta}
                    name="provDitta"
                    onChange={handleProvinciaDittaChange}
                    required={isItalianResident}
                    disabled={formData.dittaRadio === "extraResident"}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                    {provinceItaliane.map((provincia) => (
                      <option key={provincia.sigla} value={provincia.sigla}>
                        {provincia.nome} ({provincia.sigla})
                      </option>
                    ))}
                  </select>
                  {errors.provDitta && <span className="text-red-600 text-sm">{errors.provDitta}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.comune}(*)</label>
                  <select
                    value={formData.comuneDitta}
                    name="comuneDitta"
                    onChange={handleComuneDittaChange}
                    required={isItalianResident && formData.provDitta !== ''}
                    disabled={formData.dittaRadio === "extraResident"}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                    {filteredComuniDitta.map((comune) => (
                      <option key={comune.LOCALITA} value={comune.LOCALITA}>
                        {comune.LOCALITA}
                      </option>
                    ))}
                  </select>
                  {errors.comuneDitta && <span className="text-red-600 text-sm">{errors.comuneDitta}</span>}
                </div>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">

                <div className="col-span-1">
                  <label className="block text-gray-700">{staticText[formData.nationality]?.cap} (*)</label>
                  <input
                    type="text"
                    value={formData.capDitta}
                    name="capDitta"
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                    placeholder={staticText[formData.nationality]?.insertCAP}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    disabled={
                      !!formData.comuneDitta &&
                      filteredComuniDitta.some(
                        (comune) => comune.LOCALITA === formData.comuneDitta && comune.CAP
                      )
                    }
                  />
                  {errors.capDitta && <span className="text-red-600 text-sm">{errors.capDitta}</span>}
                </div>

                <div className="col-span-2">
                  <label className="block text-gray-700">{formData.nationality === "it" ? "Località " : "Location "}{!isItalyDitta && <span>(*)</span>}
                  </label>              <input
                    type="text"
                    value={formData.localitaDitta}
                    name="localitaDitta"
                    onChange={handleInputChange}
                    disabled={isItalyDitta}
                    placeholder={formData.nationality === "it" ? "Inserisci la località" : "Enter the location"}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.localitaDitta && <span className="text-red-600 text-sm">{errors.localitaDitta}</span>}
                </div>
              </div>
              <div>


              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.tel} (*)</label>
                  <input
                    type="tel"
                    value={formData.telefonoDitta}
                    name="telefonoDitta"
                    onChange={handleInputChange}
                    required
                    placeholder={staticText[formData.nationality]?.insertNumeroTelefono}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.telefonoDitta && <span className="text-red-600 text-sm">{errors.telefonoDitta}</span>}

                </div>
                <div>
                  <label className="block text-gray-700">{staticText[formData.nationality]?.fax}</label>
                  <input
                    type="tel"
                    value={formData.faxDitta}
                    name="faxDitta"
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertFax}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.faxDitta && <span className="text-red-600 text-sm">{errors.faxDitta}</span>}
                </div>
                <div>
                  <label className="block text-gray-700">Email (*)</label>
                  <input
                    type="text"
                    value={formData.emailDitta}
                    name="emailDitta"
                    onChange={handleInputChange}
                    required
                    placeholder={staticText[formData.nationality]?.insertEmail}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.emailDitta && <span className="text-red-600 text-sm">{errors.emailDitta}</span>}
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700">{staticText[formData.nationality]?.pIva} (*)</label>
                <input
                  type="text"
                  value={formData.pIva}
                  name="pIva"
                  onChange={handleInputChange}
                  required
                  maxLength={16}
                  placeholder={staticText[formData.nationality]?.insertPartitaIva}
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                />
                {errors.pIva && <span className="text-red-600 text-sm">{errors.pIva}</span>}

              </div>

              {isItalianResident && (
                <>
                  <h4 className="text-center text-xl font-bold mb-6">Dati per la trasmissione della Fatturazione Elettronica</h4>

                  <div className="mb-4">
                    <label className="block text-center text-gray-700">Codice Destinatario Univoco</label>
                    <div className="flex gap-2 justify-center items-center">
                      {valuesSDI.map((value, index) => (
                        <input
                          key={index}
                          id={`sdi${index + 1}`}
                          name={`sdi${index + 1}`}
                          type="text"
                          value={value} // Set value for each input field
                          onChange={(e) => handleChangeSDI(e, index)} // Update value on change
                          onKeyDown={(e) => handleKeyDownSDI(e, index)} // Handle backspace
                          maxLength={1}
                          placeholder="_"
                          className="w-12 h-12 text-center text-xl border border-gray-300 rounded-md focus:ring focus:ring-blue-400 sm:w-10 sm:h-10 xs:w-8 xs:h-8"
                        />
                      ))}
                    </div>
                    <p className="mt-2 text-sm text-gray-500 text-center">Inserisci un codice alfanumerico di 7 caratteri.</p>
                  </div>

                  <h6 className="text-center font-bold mb-6">Oppure</h6>

                  <div className="mb-4">
                    <label className="block text-gray-700">PEC (Posta Elettronica Certificata)</label>
                    <input
                      type="email"
                      value={formData.pecDitta}
                      name="pecDitta"
                      onChange={handleInputChange}
                      placeholder={staticText[formData.nationality]?.insertPEC}
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  {errors.sdiOrPec && (
                    <div className="text-red-600 text-sm text-center mt-2">{errors.sdiOrPec}</div>
                  )}
                </>
              )}




            </>
          )}
          {page === 4 && (
            <>
              <p className="mt-5">  {staticText[formData.nationality]?.informativaParagraph}</p>
              <PrivacyAccordion formData={formData} />
              <div className="mb-4 flex mt-5">
                <div className="mr-4 mt-5 flex items-center relative">
                  <input
                    type="checkbox"
                    name="autorizzoConsenso"
                    checked={isAuthorized}
                    onChange={handleCheckboxAuth}
                    className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                  />
                  <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                      viewBox="0 0 16 20"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <label className="ml-2 block text-gray-700 ">  {staticText[formData.nationality]?.authorize}
                  </label>
                </div>
              </div>


              <div
                className={`overflow-hidden transition-[height] duration-1000 ease-in-out ${isAuthorized ? "h-auto max-h-100 mt-5" : "h-0"
                  }`}
              >
                <h5 className="mt-10 text-center"><b>  {staticText[formData.nationality]?.racConsenso}</b><br />  {staticText[formData.nationality]?.racConsensoParagraph}
                </h5>
                <p className="mt-5 flex flex-wrap md:flex-nowrap items-center gap-y-2">
                  {staticText[formData.nationality]?.sottoscritto}&nbsp;<b>{formData.cognome} {formData.nome}</b>
                  <span className="ml-0 md:ml-5 w-full md:w-auto">
                    {staticText[formData.nationality]?.cf}&nbsp;<b>{formData.codiceFiscale}</b>
                  </span>
                </p>


                <div className="mt-10">
                  <h5><b>{staticText[formData.nationality]?.consensoA}</b></h5>
                </div>
                <div className="mb-4 flex mt-5">
                  <div className="mr-4 flex items-center">
                    <input
                      type="radio"
                      name="consensoA"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      value="allow"
                      checked={formData.consensoA === "allow"}
                      onChange={handleConsensoAChange}
                      required
                    // Gestione della selezione
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">{staticText[formData.nationality]?.allow}</label>
                  </div>

                  <div className="mr-4 flex items-center">
                    <input
                      type="radio"
                      name="consensoA"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      value="deny"
                      checked={formData.consensoA === "deny"}
                      onChange={handleConsensoAChange}
                      required
                    // Gestione della selezione
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">{staticText[formData.nationality]?.deny}</label>
                  </div>
                </div>
                <div className="mb-4 flex items-center">
                  <label className="text-gray-700 mr-2 w-auto">Email</label>
                  <input
                    type="email"
                    value={formData.emailNewsletter}
                    name="emailNewsletter"
                    disabled={isConsentDenied}
                    onChange={handleInputChange}
                    placeholder={staticText[formData.nationality]?.insertEmailNews}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.emailNewsletter && <span className="text-red-600 text-sm">{errors.emailNewsletter}</span>}
                </div>
                <div className="mb-4 flex flex-wrap">
                  {/* 'Tutti' checkbox */}
                  <div className="mr-4 flex items-center">
                    <input
                      type="checkbox"
                      className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800  custom-checkbox"
                      disabled={!isConsentGiven} // This condition can be customized based on your logic
                      checked={checkboxTuttiStates.tutti}
                      onChange={handleTuttiChange} // Handle 'Tutti' checkbox change
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                        viewBox="0 0 16 20"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className=" ml-2 text-gray-700">{formData.nationality === "it" ? 'Tutti' : 'All'}
                    </label>
                  </div>

                  {/* Individual checkboxes */}
                  {[
                    { key: 'arteModerna', label: 'Arte moderna e contemporanea', labelEn: 'Modern and contemporary art' },
                    { key: 'dipinti', label: 'Dipinti XIX e XX secolo', labelEn: '19th and 20th century paintings' },
                    { key: 'orologi', label: 'Orologi moderni e d’epoca', labelEn: 'Modern and antique watches' },
                    { key: 'vini', label: 'Vini-distillati', labelEn: 'Wines-spirits' },
                    { key: 'gioielli', label: 'Gioielli moderni e d’epoca', labelEn: 'Modern and antique Jewelry' },
                    { key: 'antiquariato', label: 'Antiquariato (Arredi e dipinti antichi)', labelEn: 'Antiques (Furniture and ancient paintings)' },
                    { key: 'tappeti', label: 'Tappeti Orientali', labelEn: 'Oriental carpets' },
                    { key: 'luxury', label: 'Luxury', labelEn: 'Luxury' },
                  ].map(({ key, label, labelEn }) => (
                    <div className="mr-4 flex items-center" key={key}>
                      <input
                        type="checkbox"
                        className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800  custom-checkbox"
                        disabled={!isConsentGiven} // Customize this condition if necessary
                        checked={checkboxTuttiStates[key]}
                        onChange={(e) => handleTuttiCheckboxChange(e, key)} // Handle individual checkbox change
                      />
                      <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                          viewBox="0 0 16 20"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                      <label className="ml-2 text-gray-700">{formData.nationality === "en" ? labelEn : label}</label>
                    </div>
                  ))}
                </div>
                {/* Validation Error */}
                {errors.checkboxes && <span className="text-red-600 text-sm">{errors.checkboxes}</span>}

                <div className="mt-10">
                  <h5><b>{staticText[formData.nationality]?.consensoB1}</b></h5>
                </div>

                <div className="mb-4 flex mt-5">
                  <div className="mr-4 flex items-center">
                    <input
                      type="radio"
                      name="consensoB1"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      value="allow"
                      checked={formData.consensoB1 === "allow"}
                      onChange={handleConsensoB1Change}
                    // Gestione della selezione
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">{staticText[formData.nationality]?.allow}</label>
                  </div>

                  <div className="mr-4 flex items-center">
                    <input
                      type="radio"
                      name="consensoB1"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      value="deny"
                      checked={formData.consensoB1 === "deny"}
                      onChange={handleConsensoB1Change}
                    // Gestione della selezione
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">{staticText[formData.nationality]?.deny}</label>
                  </div>
                </div>

                <h5><b>{staticText[formData.nationality]?.consensoB2}</b></h5>

                <div className="mb-4 flex mt-5">
                  <div className="mr-4 flex items-center">
                    <input
                      type="radio"
                      name="consensoB2"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      value="allow"
                      checked={formData.consensoB2 === "allow"}
                      onChange={handleConsensoB2Change}

                    // Gestione della selezione
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">{staticText[formData.nationality]?.allow}</label>
                  </div>

                  <div className="mr-4 flex items-center">
                    <input
                      type="radio"
                      name="consensoB2"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      value="deny"
                      checked={formData.consensoB2 === "deny"}
                      onChange={handleConsensoB2Change}
                    // Gestione della selezione
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">{staticText[formData.nationality]?.deny}</label>
                  </div>
                </div>

                <p className="mt-10">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: staticText[formData.nationality]?.privacyConsenso || ''
                    }}
                  />
                  <a href="mailto:privacy@meetingart.it" className="text-500 ml-2 hover:underline" style={{ color: 'rgb(123, 28, 62)' }}>privacy@meetingart.it</a>
                </p>
              </div>
            </>
          )}


          {page === 5 && (
            <>
              <SalesConditions onAllAccordionsOpen={setAllAccordionsOpen} formData={formData} />
              <div className="mb-4 flex mt-5">
                <div className="mr-4 flex items-center">
                  <input
                    type="checkbox"
                    className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                    value={formData.salesConditionArticle}
                    name="salesConditionArticle"
                    onChange={handleArticleCheckboxChange}
                    checked={formData.salesConditionArticle}
                  />
                  <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                      viewBox="0 0 16 20"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <label className=" ml-2 block text-gray-700">
                    {staticText[formData.nationality]?.salesCheck1}
                  </label>
                </div>
              </div>
              <div className="mb-4 flex mt-5">
                <div className="mr-4 flex items-center">
                  <input
                    type="checkbox"
                    className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800  custom-checkbox"
                    value={formData.salesCondition}
                    name="salesCondition"
                    onChange={handleCheckboxChange}
                    checked={formData.salesCondition}
                  />
                  <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                      viewBox="0 0 16 20"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <label className="ml-2 block text-gray-700">
                    {staticText[formData.nationality]?.salesCheck2}
                  </label>
                </div>
              </div>
            </>
          )}

          {page === 6 && (
            <>
              <h3 className="text-center text-2xl font-bold mb-6"> {staticText[formData.nationality]?.antiriciclaggio1}<br />
                {staticText[formData.nationality]?.antiriciclaggio2}
                <span className="relative cursor-pointer" style={{ marginLeft: "4px" }}> {/* Add margin for spacing */}
                  <FaInfoCircle
                    data-tooltip-id="decTooltip"
                    data-tooltip-html={tooltip[formData.nationality]?.tooltipDecreto} // Enable HTML in tooltip
                    className="ml-1 inline-block text-black-100 w-50 absolute -top-1 -right-4 hidden sm:inline-block"
                    size={13}
                  />
                </span></h3>
              <h4 className="mt-10 mb-10 text-center font-bold"> {staticText[formData.nationality]?.sottoscritto}</h4>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                {/* Nome Field */}
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.cognome}</label>
                  <input
                    type="text"
                    value={formData.cognome}
                    name="cognome"
                    onChange={handleInputChange}
                    disabled
                    maxLength={100}
                    placeholder="Inserisci il cognome"
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.cognome && <span className="text-red-600 text-sm">{errors.cognome}</span>}
                </div>

                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.nome}</label>
                  <input
                    type="text"
                    value={formData.nome}
                    name="nome"
                    onChange={handleInputChange}
                    disabled
                    maxLength={100}
                    placeholder="Inserisci il nome"
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.nome && <span className="text-red-600 text-sm">{errors.nome}</span>}
                </div>
                {/* Sesso Field (Dropdown) */}
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.sesso}</label>
                  <input
                    type="text"
                    value={formData.nationality === "it" ? formData.sesso :
                      formData.sesso === "Femmina" ? "Female" :
                        formData.sesso === "Maschio" ? "Male" : ""}
                    name="sesso"
                    onChange={handleInputChange}
                    disabled
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                  </input>
                  {errors.sesso && <span className="text-red-600 text-sm">{errors.sesso}</span>}
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-gray-700"> {staticText[formData.nationality]?.codFiscale}</label>
                <input
                  type="text"
                  value={formData.codiceFiscale}
                  name="codiceFiscale"
                  onChange={handleInputChange}
                  placeholder="Inserisci il codice fiscale"
                  maxLength={30}
                  disabled
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                />
                {errors.codiceFiscale && <span className="text-red-600 text-sm">{errors.codiceFiscale}</span>}
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                
              {formData.comuneNascita.trim() !== "" && (
                  <div>
                    <label className="block text-gray-700"> {staticText[formData.nationality]?.natoA}</label>
                    <input
                      type="text"
                      value={formData.comuneNascita}
                      name="comuneNascita"
                      onChange={handleInputChange}
                      disabled
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    />
                    {errors.comuneNascita && <span className="text-red-600 text-sm">{errors.comuneNascita}</span>}
                  </div>
                )}

                {formData.luogoNascita.trim() !== "" && (
                  <div>
                    <label className="block text-gray-700"> {staticText[formData.nationality]?.natoA}</label>
                    <input
                      type="text"
                      value={formData.luogoNascita}
                      name="luogoNascita"
                      onChange={handleInputChange}
                      disabled
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    />
                    {errors.luogoNascita && <span className="text-red-600 text-sm">{errors.luogoNascita}</span>}
                  </div>
                )}
                <div>
                  <label className="block text-gray-700"> {formData.nationality === "en" ? "on" : "il"}
                  </label>
                  <input
                    type="date"
                    value={formData.dataNascita}
                    name="dataNascita"
                    onChange={handleInputChange}
                    disabled
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.dataNascita && <span className="text-red-600 text-sm">{errors.dataNascita}</span>}
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-2">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.indirizzo}</label>
                  <input
                    type="text"
                    value={formData.indirizzo}
                    name="indirizzo"
                    onChange={handleInputChange}
                    disabled
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.indirizzo && <span className="text-red-600 text-sm">{errors.indirizzo}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.numCiv}</label>
                  <input
                    type="text"
                    value={formData.numCiv}
                    name="numCiv"
                    onChange={handleInputChange}
                    disabled
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.numCiv && <span className="text-red-600 text-sm">{errors.numCiv}</span>}
                </div>

              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
              <div className="col-span-1">
                <label className="block text-gray-700">{staticText[formData.nationality]?.country}</label>
                <input
                  type="text"
                  value={
                    (() => {
                      const selectedCountry = countries.find(country => country.iso === formData.stato);
                      if (!selectedCountry) return ""; // Avoid errors if country not found
                      return formData.nationality === "it" ? selectedCountry.name : selectedCountry.nameEn;
                    })()
                  }
                  name="stato"
                  disabled
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md bg-gray-100"
                />
                {errors.stato && <span className="text-red-600 text-sm">{errors.stato}</span>}
              </div>


                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.prov}</label>
                  <input
                    type="text"
                    value={
                      provinceItaliane.find((provincia) => provincia.sigla === formData.provincia)?.nome || ''
                    }
                    name="provincia"
                    disabled
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md bg-gray-100"
                  />
                  {errors.provincia && <span className="text-red-600 text-sm">{errors.provincia}</span>}
                </div>

                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.comune}</label>
                  <input
                    type="text"
                    value={formData.comuneResid}
                    name="comuneResid"
                    disabled
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md bg-gray-100"
                  />
                  {errors.comuneResid && <span className="text-red-600 text-sm">{errors.comuneResid}</span>}
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">

                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.cap}</label>
                  <input
                    type="text"
                    value={formData.cap}
                    name="cap"
                    onChange={handleInputChange}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    disabled
                  />
                  {errors.cap && <span className="text-red-600 text-sm">{errors.cap}</span>}
                </div>

                <div className="col-span-2">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.luogoResid}</label>
                  <input
                    type="text"
                    value={formData.localitaResid}
                    name="localitaResid"
                    disabled
                    onChange={handleInputChange}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.localitaResid && <span className="text-red-600 text-sm">{errors.localitaResid}</span>}
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-gray-700"> <span
                  dangerouslySetInnerHTML={{
                    __html: staticText[formData.nationality]?.identification || ''
                  }}
                /></label>
                <input
                  type="text"
                  value={`${formData.nationality === "it" ? formData.tipoDoc :
                    formData.tipoDoc === "CARTA D'IDENTITÀ" ? "IDENTITY DOCUMENT" :
                      formData.tipoDoc === "PASSAPORTO" ? "PASSPORT" :
                        formData.tipoDoc === "PATENTE DI GUIDA" ? "DRIVER'S LICENCE" : ""} - ${formData.numDoc || ''}`}
                  name="numDoc"
                  disabled
                  onChange={handleInputChange}
                  placeholder="Inserisci il numero del documento"
                  className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                />
                {errors.numDoc && <span className="text-red-600 text-sm">{errors.numDoc}</span>}
              </div>

              <div className="flex items-center justify-between mt-10 flex-wrap sm:flex-nowrap ">
                <p className="w-full sm:w-auto mb-2 sm:mb-0 ">
                  {staticText[formData.nationality]?.dom} <b> {staticText[formData.nationality]?.domNotResid}</b>
                </p>
                <label className="inline-flex items-center cursor-pointer">
                  <span className=" text-gray-700  sm:text-base sm:mt-0">
                    {isDomicileEnabled ? staticText[formData.nationality]?.disabilita : staticText[formData.nationality]?.abilita}
                  </span>
                  <input
                    type="checkbox"
                    className="absolute opacity-0 w-0 h-0 peer"
                    checked={isDomicileEnabled}
                    onChange={handleToggleChange}
                  />
                  <div className="ml-2 relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#7B1C3E] "></div>
                </label>
              </div>

              <div className="mb-4 mt-5 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-2">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.indirizzoDom}</label>
                  <input
                    type="text"
                    value={formData.indirizzoDom}
                    name="indirizzoDom"
                    maxLength={80}
                    onChange={handleInputChange}
                    required={isDomicileEnabled}
                    disabled={!isDomicileEnabled}
                    placeholder={staticText[formData.nationality]?.insertIndirizzo}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"

                  />
                  {errors.indirizzoDom && <span className="text-red-600 text-sm">{errors.indirizzoDom}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.numCiv}</label>
                  <input
                    type="text"
                    value={formData.numCivDom}
                    name="numCivDom"
                    maxLength={10}
                    onChange={handleInputChange}
                    disabled={!isDomicileEnabled}
                    placeholder={staticText[formData.nationality]?.insertNumeroCivico}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                </div>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.country}</label>
                  <select
                    value={formData.statoDom}
                    name="statoDom"
                    onChange={handleCountryDomChange}
                    disabled={!isDomicileEnabled}
                    required={isDomicileEnabled}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaStato}</option>
                    {countries
                      .filter(country => country.iso !== 'YU')
                      .sort((a, b) => {
                        const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                        const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                        return nameA.localeCompare(nameB); // Sort alphabetically by the selected name
                      })
                      .map((country) => (
                        <option key={country.iso} value={country.iso}>
                          {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                        </option>
                      ))}
                  </select>
                  {errors.statoDom && <span className="text-red-600 text-sm">{errors.statoDom}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.prov}</label>
                  <select
                    value={formData.provDom}
                    name="provDom"
                    onChange={handleProvinciaDomChange}
                    required={isItalyDom && isDomicileEnabled}
                    disabled={!isItalyDom || !isDomicileEnabled}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                    {provinceItaliane.map((provincia) => (
                      <option key={provincia.sigla} value={provincia.sigla}>
                        {provincia.nome} ({provincia.sigla})
                      </option>
                    ))}
                  </select>
                  {errors.provDom && <span className="text-red-600 text-sm">{errors.provDom}</span>}
                </div>
                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.comune}</label>
                  <select
                    value={formData.comuneDom}
                    name="comuneDom"
                    onChange={handleComuneDomChange}
                    required={isItalyDom && (isDomicileEnabled || formData.provDom !== '')}
                    disabled={(!isItalyDom && formData.provDom === '') || !isDomicileEnabled}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  >
                    <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                    {filteredComuniDom.map((comune) => (
                      <option key={comune.LOCALITA} value={comune.LOCALITA}>
                        {comune.LOCALITA}
                      </option>
                    ))}
                  </select>
                  {errors.comuneDom && <span className="text-red-600 text-sm">{errors.comuneDom}</span>}
                </div>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">

                <div className="col-span-1">
                  <label className="block text-gray-700"> {staticText[formData.nationality]?.cap}</label>
                  <input
                    type="text"
                    value={formData.capDom}
                    name="capDom"
                    onChange={handleInputChange}
                    maxLength={10}
                    placeholder={staticText[formData.nationality]?.insertCAP}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    required={isItalyDom && formData.provDom !== '' && isDomicileEnabled}
                    disabled={
                      (!!formData.comuneDom &&
                        filteredComuniDom.some(
                          (comune) => comune.LOCALITA === formData.comuneDom && comune.CAP
                        )) || !isDomicileEnabled
                    }
                  />
                  {errors.capDom && <span className="text-red-600 text-sm">{errors.capDom}</span>}
                </div>

                <div className="col-span-2">
                  <label className="block text-gray-700">  {staticText[formData.nationality]?.luogoDom} {!isItalyDom && <span>(*)</span>}
                  </label>
                  <input
                    type="text"
                    value={formData.localitaDom}
                    name="localitaDom"
                    maxLength={80}
                    onChange={handleInputChange}
                    disabled={!isDomicileEnabled || isItalyDom}
                    placeholder={staticText[formData.nationality]?.insertLocalitaDomicilio}
                    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                  />
                  {errors.localitaDom && <span className="text-red-600 text-sm">{errors.localitaDom}</span>}
                </div>
              </div>



            </>
          )}
          {page === 7 && (
            <>
              <div>
                <p style={{ lineHeight: "1.8" }}> {/* Adjust lineHeight for vertical spacing */}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: staticText[formData.nationality]?.antiricParagraph || ''
                    }}
                  />
                  <span className="relative cursor-pointer" style={{ marginLeft: "4px" }}> {/* Add margin for spacing */}
                    {staticText[formData.nationality]?.riciclaggio}
                    <FaInfoCircle
                      data-tooltip-id="ricTooltip"
                      data-tooltip-html={tooltip[formData.nationality]?.tooltipRic} // Enable HTML in tooltip
                      className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4 hidden sm:inline-block"
                      size={13}
                    />
                  </span>
                  <span className="relative cursor-pointer" style={{ marginLeft: "4px" }}> {/* Add margin for spacing */}
                    &nbsp;{staticText[formData.nationality]?.terrorismo}
                    <FaInfoCircle
                      data-tooltip-id="terTooltip"
                      data-tooltip-html={tooltip[formData.nationality]?.tooltipTer} // Enable HTML in tooltip
                      className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4 hidden sm:inline-block"
                      size={13}
                    />
                  </span>
                  , {staticText[formData.nationality]?.resp}

                </p>
                <h4 className="mt-10 mb-10 text-center font-bold">{staticText[formData.nationality]?.dichiara} </h4>
              </div>


              <div className="mb-4 mt-5">

                {/* Radio button "Di non essere" */}
                <div>
                  {/* Radio button "Di non essere" */}
                  <div className="mr-4 mt-5 flex items-center relative">
                    {/* Radio button "Non essere" */}
                    <input
                      type="radio"
                      name="pepOption"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]" // Changed rounded-full to rounded-none for square shape
                      checked={!isPepSelected}
                      onChange={() => handlePepChange(false)} // Pass 'false' to indicate "nonPep" is selected
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: staticText[formData.nationality]?.nonPep || ''
                        }}
                      /> - {" "}
                      <span className="relative cursor-pointer">
                        PEP
                        <FaInfoCircle
                          data-tooltip-id="pepTooltip"
                          data-tooltip-html={tooltip[formData.nationality]?.tooltipPep} // Enable HTML in tooltip
                          className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4 hidden sm:inline-block"
                          size={13}
                        />
                        {staticText[formData.nationality]?.pepNazionale}
                      </span>
                    </label>
                  </div>

                  {/* Radio button "Di essere" */}
                  <div className="mr-4 mt-5 flex items-center relative">
                    <input
                      type="radio"
                      name="pepOption"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]" // Changed rounded-full to rounded-none for square shape
                      checked={isPepSelected}
                      onChange={() => handlePepChange(true)} // Pass 'true' to indicate "pep" is selected
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: staticText[formData.nationality]?.pep || ''
                        }}
                      />
                      -{" "}
                      <span className="relative cursor-pointer">
                        PEP  {staticText[formData.nationality]?.pepNazionale}
                      </span>
                    </label>
                  </div>

                </div>
                {/* Textarea con animazione condizionale */}
                <div
                  className={`overflow-hidden transition-[height] duration-1000 ease-in-out ${isPepSelected ? "h-auto max-h-[150px] mt-5" : "h-0"
                    }`}
                >
                  <textarea
                    name="pepText"
                    value={formData.pepText}
                    maxLength="200"
                    onChange={handleInputChange}
                    required={isPepSelected}
                    placeholder={staticText[formData.nationality]?.insertTextPep}
                    rows="3"
                    className="p-2 border border-gray-300 rounded-md w-full"

                  />
                  <p className="text-sm text-gray-600">
                    {formData.pepText.length} / 200
                  </p>
                  {errors.pepText && <span className="text-red-600 text-sm">{errors.pepText}</span>}

                </div>
              </div>
              <div className="mb-4 mt-10">

                <h4 className=" mb-10 text-center font-bold">  {staticText[formData.nationality]?.clienteTitolare} </h4>
                {/* Radio button "Di agire in nome e per conto proprio" */}
                <div className="mr-4 mt-5 flex items-center">
                  <input
                    type="radio"
                    name="titolareOption"
                    className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                    checked={!isTitolareSelected}
                    onChange={() => handleTitolareChange(false)} // Pass 'false' for "ownAccount"
                  />
                  <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                      viewBox="-2 0 19 19"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <label className="ml-2 block text-gray-700">
                    {staticText[formData.nationality]?.notTitolare}
                  </label>
                </div>

                {/* Radio button "Di agire in nome e per conto di" */}
                <div className="mr-4 mt-5 flex items-center">
                  <input
                    type="radio"
                    name="titolareOption"
                    className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                    checked={isTitolareSelected}
                    onChange={() => handleTitolareChange(true)} // Pass 'true' for "thirdParty"
                  />
                  <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                      viewBox="-2 0 19 19"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <label className="ml-2 block text-gray-700">
                    {staticText[formData.nationality]?.titolare}
                    <span className="relative cursor-pointer">
                      <FaInfoCircle
                        data-tooltip-id="titolareTooltip"
                        data-tooltip-html={tooltip[formData.nationality]?.tooltipTitolare}// Tooltip content
                        className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4 hidden sm:inline-block"
                        size={13}
                      />
                    </span>
                  </label>
                </div>
              </div>



            </>
          )}

          {page === 8 && (
            <>
              {isTitolareSelected ? (
                <>

                  <p className="mt-5 mb-5" style={{ lineHeight: "1.8" }}>{staticText[formData.nationality]?.compilazioneTitolare} </p>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    {/* Nome Field */}
                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.cognome} (*)</label>
                      <input
                        type="text"
                        value={formData.cognomeTitolare}
                        name="cognomeTitolare"
                        onChange={handleInputChange}
                        required
                        maxLength={100}
                        placeholder={staticText[formData.nationality]?.insertCognome}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.cognomeTitolare && <span className="text-red-600 text-sm">{errors.cognomeTitolare}</span>}
                    </div>

                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.nome} (*)</label>
                      <input
                        type="text"
                        value={formData.nomeTitolare}
                        name="nomeTitolare"
                        onChange={handleInputChange}
                        required
                        maxLength={100}
                        placeholder={staticText[formData.nationality]?.insertNome}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.nomeTitolare && <span className="text-red-600 text-sm">{errors.nomeTitolare}</span>}
                    </div>
                    {/* Sesso Field (Dropdown) */}
                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.sesso} (*)</label>
                      <select
                        value={formData.sessoTitolare}
                        name="sessoTitolare"
                        onChange={handleInputChange}
                        required
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled> {formData.nationality === "it" ? 'Seleziona il tuo genere' : "Select your gender"}</option>
                        <option value="Maschio"> {formData.nationality === "it" ? 'Maschio' : "Male"}</option>
                        <option value="Femmina"> {formData.nationality === "it" ? 'Femmina' : "Female"}</option>
                      </select>
                      {errors.sessoTitolare && <span className="text-red-600 text-sm">{errors.sessoTitolare}</span>}
                    </div>
                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div className="col-span-2">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.indirizzo} (*)</label>
                      <input
                        type="text"
                        value={formData.indirizzoTitolare}
                        name="indirizzoTitolare"
                        onChange={handleInputChange}
                        required
                        maxLength={80}
                        placeholder={staticText[formData.nationality]?.insertIndirizzo}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.indirizzoTitolare && <span className="text-red-600 text-sm">{errors.indirizzoTitolare}</span>}
                    </div>
                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.numCiv}</label>
                      <input
                        type="text"
                        value={formData.numCivTitolare}
                        name="numCivTitolare"
                        maxLength={10}
                        onChange={handleInputChange}
                        placeholder={staticText[formData.nationality]?.insertNumeroCivico}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.numCivTitolare && <span className="text-red-600 text-sm">{errors.numCivTitolare}</span>}
                    </div>

                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.country} (*)</label>
                      <select
                        value={formData.statoTitolare}
                        name="statoTitolare"
                        onChange={handleCountryTitolareChange}
                        required
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaStato}</option>
                        {countries
                          .filter(country => country.iso !== 'YU')
                          .sort((a, b) => {
                            const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                            const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                            return nameA.localeCompare(nameB); // Sort alphabetically by the selected name
                          })
                          .map((country) => (
                            <option key={country.iso} value={country.iso}>
                              {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                            </option>
                          ))}
                      </select>
                      {errors.statoTitolare && <span className="text-red-600 text-sm">{errors.statoTitolare}</span>}
                    </div>
                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.prov} (*)</label>
                      <select
                        value={formData.provinciaTitolare}
                        name="provinciaTitolare"
                        onChange={handleProvinciaTitolareChange}
                        required={isItalyTitolare}
                        disabled={!isItalyTitolare}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                        {provinceItaliane.map((provincia) => (
                          <option key={provincia.sigla} value={provincia.sigla}>
                            {provincia.nome} ({provincia.sigla})
                          </option>
                        ))}
                      </select>
                      {errors.provinciaTitolare && <span className="text-red-600 text-sm">{errors.provinciaTitolare}</span>}
                    </div>
                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.comune}  (*)</label>
                      <select
                        value={formData.comuneResidTitolare}
                        name="comuneResidTitolare"
                        onChange={handleComuneTitolareChange}
                        required={isItalyTitolare && formData.provinciaTitolare !== ''}
                        disabled={!isItalyTitolare && formData.provinciaTitolare === ''}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                        {filteredComuniResTitolare.map((comune) => (
                          <option key={comune.LOCALITA} value={comune.LOCALITA}>
                            {comune.LOCALITA}
                          </option>
                        ))}
                      </select>
                      {errors.comuneResidTitolare && <span className="text-red-600 text-sm">{errors.comuneResidTitolare}</span>}
                    </div>
                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">

                    <div className="col-span-1">
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.cap} (*)</label>
                      <input
                        type="text"
                        value={formData.capTitolare}
                        name="capTitolare"
                        onChange={handleInputChange}
                        required
                        maxLength={10}
                        placeholder={staticText[formData.nationality]?.insertCAP}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                        disabled={
                          !!formData.comuneResidTitolare &&
                          filteredComuniRes.some(
                            (comune) => comune.LOCALITA === formData.comuneResidTitolare && comune.CAP
                          )
                        }
                      />
                      {errors.capTitolare && <span className="text-red-600 text-sm">{errors.capTitolare}</span>}
                    </div>

                    <div className="col-span-2">
                      <label className="block text-gray-700">  {staticText[formData.nationality]?.luogoResid} {!isItalyTitolare && <span>(*)</span>}
                      </label>
                      <input
                        type="text"
                        value={formData.localitaResidTitolare}
                        name="localitaResidTitolare"
                        onChange={handleInputChange}
                        maxLength={80}
                        disabled={isItalyTitolare}
                        placeholder={staticText[formData.nationality]?.insertLocalitaResidenza}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.localitaResidTitolare && <span className="text-red-600 text-sm">{errors.localitaResidTitolare}</span>}
                    </div>
                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div>
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.dataNascita} (*)</label>
                      <input
                        type="date"
                        value={formData.dataNascitaTitolare}
                        name="dataNascitaTitolare"
                        onChange={handleInputChange}
                        required
                        max={formattedDate}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.dataNascitaTitolare && <span className="text-red-600 text-sm">{errors.dataNascitaTitolare}</span>}

                    </div>

                    <div>
                      <label className="block text-gray-700"> {staticText[formData.nationality]?.countryNascita} (*)</label>
                      <select
                        value={formData.statoNascitaTitolare}
                        name="statoNascitaTitolare"
                        onChange={handleCountryNascitaTitolareChange}
                        required
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaStato}</option>
                        {countries
                          .sort((a, b) => {
                            const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                            const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                            return nameA.localeCompare(nameB); // Sort alphabetically by the selected name
                          })
                          .map((country) => (
                            <option key={country.iso} value={country.iso}>
                              {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                            </option>
                          ))}
                      </select>
                      {errors.statoNascitaTitolare && <span className="text-red-600 text-sm">{errors.statoNascitaTitolare}</span>}
                    </div>

                    <div className="col-span-1">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.provNascita}  (*)</label>
                      <select
                        value={formData.provinciaNascitaTitolare}
                        name="provinciaNascitaTitolare"
                        onChange={handleProvinciaNascitaTitolareChange}
                        required={isItalyNascitaTitolare}
                        disabled={!isItalyNascitaTitolare}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                        {provinceItaliane.map((provincia) => (
                          <option key={provincia.sigla} value={provincia.sigla}>
                            {provincia.nome} ({provincia.sigla})
                          </option>
                        ))}
                      </select>
                      {errors.provinciaNascitaTitolare && <span className="text-red-600 text-sm">{errors.provinciaNascitaTitolare}</span>}
                    </div>
                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div>
                      <label className="block text-gray-700">{staticText[formData.nationality]?.comuneNascita} (*)</label>
                      <select
                        value={formData.comuneNascitaTitolare}
                        name="comuneNascitaTitolare"
                        onChange={handleInputChange}
                        required={isItalyNascitaTitolare}
                        disabled={!isItalyNascitaTitolare || !formData.provinciaNascitaTitolare}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                        {filteredComuniTitolare.map((comune) => (
                          <option key={comune.CODICE_COMUNALE} value={comune.LOCALITA}>
                            {comune.LOCALITA}
                          </option>
                        ))}
                      </select>
                      {errors.comuneNascitaTitolare && <span className="text-red-600 text-sm">{errors.comuneNascitaTitolare}</span>}
                    </div>
                    <div className="col-span-2">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.luogoNascita} {!isItalyNascitaTitolare && <span>(*)</span>}
                      </label>
                      <input
                        type="text"
                        value={formData.luogoNascitaTitolare}
                        name="luogoNascitaTitolare"
                        onChange={handleInputChange}
                        disabled={isItalyNascitaTitolare}
                        placeholder={staticText[formData.nationality]?.insertLocalitaNascita}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.luogoNascitaTitolare && <span className="text-red-600 text-sm">{errors.luogoNascitaTitolare}</span>}
                    </div>

                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">{staticText[formData.nationality]?.codFiscale}
                      {formData.nationality === "en" && (formData.statoTitolare === "IT" || formData.statoNascitaTitolare === "IT") && (
                        " (*) (Format XXXYYY00A00ZZZZW)"
                      )}
                      {formData.nationality === "it" && (formData.statoTitolare === "IT" || formData.statoNascitaTitolare === "IT") && (
                        " (*) (Formato XXXYYY00A00ZZZZW)"
                      )}</label>
                    <input
                      type="text"
                      value={formData.codiceFiscaleTitolare}
                      name="codiceFiscaleTitolare"
                      onChange={handleInputChange}
                      required={isCodFiscaleTitolareRequired}
                      maxLength={30}
                      placeholder={staticText[formData.nationality]?.insertCodiceFiscale}
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    />
                    {errors.codiceFiscaleTitolare && <span className="text-red-600 text-sm">{errors.codiceFiscaleTitolare}</span>}

                  </div>

                  <div className="flex items-center justify-between mt-10 flex-wrap sm:flex-nowrap ">
                    <p className="w-full sm:w-auto mb-2 sm:mb-0 ">
                      {staticText[formData.nationality]?.dom}<b>{staticText[formData.nationality]?.domNotResid}</b>
                    </p>
                    <label className="inline-flex items-center cursor-pointer">
                      <span className=" text-gray-700  sm:text-base  sm:mt-0">
                        {isDomicileTitolareEnabled ? staticText[formData.nationality]?.disabilita : staticText[formData.nationality]?.abilita}
                      </span>
                      <input
                        type="checkbox"
                        className="absolute opacity-0 w-0 h-0 peer"
                        checked={isDomicileTitolareEnabled}
                        onChange={handleToggleTitolareChange}
                      />
                      <div className="ml-2 relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#7B1C3E] "></div>
                    </label>
                  </div>

                  <div className="mb-4 mt-5 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div className="col-span-2">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.indirizzoDom}</label>
                      <input
                        type="text"
                        value={formData.indirizzoDomTitolare}
                        name="indirizzoDomTitolare"
                        onChange={handleInputChange}
                        maxLength={80}
                        disabled={!isDomicileTitolareEnabled}
                        required={isDomicileTitolareEnabled}
                        placeholder={staticText[formData.nationality]?.insertIndirizzo}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.indirizzoDomTitolare && <span className="text-red-600 text-sm">{errors.indirizzoDomTitolare}</span>}
                    </div>
                    <div className="col-span-1">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.numCiv}</label>
                      <input
                        type="text"
                        value={formData.numCivDomTitolare}
                        name="numCivDomTitolare"
                        maxLength={10}
                        disabled={!isDomicileTitolareEnabled}
                        onChange={handleInputChange}
                        placeholder={staticText[formData.nationality]?.insertNumeroCivico}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div className="col-span-1">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.country}</label>
                      <select
                        value={formData.statoDomTitolare}
                        name="statoDomTitolare"
                        disabled={!isDomicileTitolareEnabled}
                        required={isDomicileTitolareEnabled}
                        onChange={handleCountryTitolareDomChange}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaStato}</option>
                        {countries
                          .filter(country => country.iso !== 'YU')
                          .sort((a, b) => {
                            const nameA = formData.nationality === "en" && a.nameEn ? a.nameEn : a.name;
                            const nameB = formData.nationality === "en" && b.nameEn ? b.nameEn : b.name;
                            return nameA.localeCompare(nameB); // Sort alphabetically by the selected name
                          })
                          .map((country) => (
                            <option key={country.iso} value={country.iso}>
                              {formData.nationality === "en" && country.nameEn ? country.nameEn : country.name}
                            </option>
                          ))}
                      </select>
                      {errors.statoDomTitolare && <span className="text-red-600 text-sm">{errors.statoDomTitolare}</span>}
                    </div>
                    <div className="col-span-1">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.prov}</label>
                      <select
                        value={formData.provDomTitolare}
                        name="provDomTitolare"
                        onChange={handleProvinciaTitolareDomChange}
                        required={isItalyDomTitolare && isDomicileTitolareEnabled}
                        disabled={!isItalyDomTitolare || !isDomicileTitolareEnabled}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaProvincia}</option>
                        {provinceItaliane.map((provincia) => (
                          <option key={provincia.sigla} value={provincia.sigla}>
                            {provincia.nome} ({provincia.sigla})
                          </option>
                        ))}
                      </select>
                      {errors.provDomTitolare && <span className="text-red-600 text-sm">{errors.provDomTitolare}</span>}
                    </div>
                    <div className="col-span-1">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.comune}</label>
                      <select
                        value={formData.comuneDomTitolare}
                        name="comuneDomTitolare"
                        onChange={handleComuneTitolareDomChange}
                        required={isItalyDomTitolare && (isDomicileTitolareEnabled || formData.provDomTitolare !== '')}
                        disabled={(!isItalyDomTitolare && formData.provDomTitolare === '') || !isDomicileTitolareEnabled}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>{staticText[formData.nationality]?.selezionaComune}</option>
                        {filteredComuniDomTitolare.map((comune) => (
                          <option key={comune.LOCALITA} value={comune.LOCALITA}>
                            {comune.LOCALITA}
                          </option>
                        ))}
                      </select>
                      {errors.comuneDomTitolare && <span className="text-red-600 text-sm">{errors.comuneDomTitolare}</span>}
                    </div>
                  </div>
                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">

                    <div className="col-span-1">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.cap}</label>
                      <input
                        type="text"
                        value={formData.capDomTitolare}
                        name="capDomTitolare"
                        onChange={handleInputChange}
                        maxLength={10}
                        placeholder={staticText[formData.nationality]?.insertCAP}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                        required={isItalyDomTitolare && formData.provDomTitolare !== '' && isDomicileTitolareEnabled}
                        disabled={
                          !!formData.comuneDomTitolare &&
                          filteredComuniDomTitolare.some(
                            (comune) => comune.LOCALITA === formData.comuneDomTitolare && comune.CAP
                          ) || !isDomicileTitolareEnabled
                        }
                      />
                      {errors.capDomTitolare && <span className="text-red-600 text-sm">{errors.capDomTitolare}</span>}
                    </div>

                    <div className="col-span-2">
                      <label className="block text-gray-700">  {staticText[formData.nationality]?.luogoDom} {!isItalyDomTitolare && <span>(*)</span>}
                      </label>              <input
                        type="text"
                        value={formData.localitaDomTitolare}
                        name="localitaDomTitolare"
                        onChange={handleInputChange}
                        maxLength={80}
                        disabled={!isDomicileTitolareEnabled || isItalyDomTitolare}
                        placeholder={staticText[formData.nationality]?.insertLocalitaDomicilio}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.localitaDomTitolare && <span className="text-red-600 text-sm">{errors.localitaDomTitolare}</span>}
                    </div>
                  </div>

                  <div className="mb-4 mt-10">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: staticText[formData.nationality]?.identityTitolare || ''
                      }}
                    />
                  </div>

                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-gray-700">{staticText[formData.nationality]?.tipoDoc} (*)</label>
                      <select
                        value={formData.tipoDocTitolare}
                        name="tipoDocTitolare"
                        onChange={handleInputChange}
                        required
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>
                          {formData.nationality === "it" ? 'Seleziona il tipo di documento' : "Select the document type"}
                        </option>
                        <option value="CARTA D'IDENTITÀ">  {formData.nationality === "it" ? 'CARTA D\'IDENTITÀ' : "IDENTITY DOCUMENT"}</option>
                        <option value="PASSAPORTO">  {formData.nationality === "it" ? 'PASSAPORTO' : "PASSPORT"} </option>
                        <option value="PATENTE DI GUIDA">  {formData.nationality === "it" ? 'PATENTE DI GUIDA' : "DRIVER'S LICENSE"}</option>
                      </select>
                      {errors.tipoDocTitolare && <span className="text-red-600 text-sm">{errors.tipoDocTitolare}</span>}
                    </div>
                    <div>
                      <label className="block text-gray-700">{staticText[formData.nationality]?.numDoc}  (*)</label>
                      <input
                        type="text"
                        value={formData.numDocTitolare}
                        name="numDocTitolare"
                        onChange={handleInputChange}
                        required
                        maxLength={20}
                        placeholder={staticText[formData.nationality]?.insertNumeroDocumento}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.numDocTitolare && <span className="text-red-600 text-sm">{errors.numDocTitolare}</span>}

                    </div>
                  </div>

                  <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-gray-700">{staticText[formData.nationality]?.dataDoc}  (*)</label>
                      <input
                        type="date"
                        value={formData.dataDocTitolare}
                        name="dataDocTitolare"
                        onChange={handleInputChange}
                        required
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.dataDocTitolare && <span className="text-red-600 text-sm">{errors.dataDocTitolare}</span>}
                    </div>
                    <div>
                      <label className="block text-gray-700">{staticText[formData.nationality]?.dataScadDoc}  (*)</label>
                      <input
                        type="date"
                        value={formData.dataScadDocTitolare}
                        name="dataScadDocTitolare"
                        onChange={handleInputChange}
                        required
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.dataScadDocTitolare && <span className="text-red-600 text-sm">{errors.dataScadDocTitolare}</span>}
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="block text-gray-700">{staticText[formData.nationality]?.rilascioDoc} (*)</label>
                    <input
                      type="text"
                      value={formData.rilascioDocTitolare}
                      name="rilascioDocTitolare"
                      onChange={handleInputChange}
                      required
                      maxLength={100}
                      placeholder={staticText[formData.nationality]?.insertEnteRilascioDocumento}
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    />
                    {errors.rilascioDocTitolare && <span className="text-red-600 text-sm">{errors.rilascioDocTitolare}</span>}

                  </div>


                  <label className="mb-5 mt-5 block text-gray-700">        <span
                    dangerouslySetInnerHTML={{
                      __html: staticText[formData.nationality]?.docParagraph || ''
                    }}
                  />      </label>
                  <div
                    className="mb-4 w-full py-9 bg-gray-50 rounded-2xl border border-gray-300 gap-3 grid border-dashed"
                    onDragOver={handleDragOverTitolare}
                    onDrop={handleDropTitolare}
                  >
                    <div className="grid gap-1">
                      <h2 className="text-center text-gray-400 text-xs leading-4">
                        {staticText[formData.nationality]?.format}
                      </h2>
                    </div>
                    <div className="grid gap-2">
                      <h4 className="text-center text-gray-900 text-sm font-medium leading-snug">
                        {staticText[formData.nationality]?.drag}
                      </h4>
                      <div className="flex items-center justify-center">
                        <label>
                          <input
                            type="file"
                            hidden
                            name="docsTitolare"
                            multiple
                            required
                            ref={fileInputRefTitolare}
                            onChange={handleInputChange}
                          />
                          <div className="flex w-28 h-9 px-2 flex-col primary-color rounded-full shadow text-white text-xs font-semibold leading-4 items-center justify-center cursor-pointer focus:outline-none">
                            {staticText[formData.nationality]?.chooseDocs}
                          </div>
                        </label>

                        {/* Pulsante "Cancella i file" visibile se ci sono file caricati */}
                        {uploadedFilesTitolare.length > 0 && (
                          <button
                            type="button"
                            className="ml-4 bg-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm font-medium"
                            onClick={removeFilesTitolare}
                          >
                            {staticText[formData.nationality]?.removeDocs}
                          </button>
                        )}
                      </div>

                      {/* Visualizza i file caricati */}
                      {uploadedFilesTitolare.length > 0 && (
                        <ul className="text-center text-gray-900 text-sm mt-4">
                          {uploadedFilesTitolare.map((file, index) => (
                            <li key={index} className="font-semibold">
                              {file.name}
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* Visualizza errori */}
                      {errors.docsTitolare && (
                        <span className="text-red-600 text-center text-sm">{errors.docsTitolare}</span>
                      )}
                    </div>
                  </div>


                  <div className="mb-4 mt-20">
                    <label className="block text-gray-700">{staticText[formData.nationality]?.rapportoTitolare} (*)</label>
                    <input
                      type="text"
                      name="relTitolare"
                      value={formData.relTitolare}
                      onChange={handleInputChange}
                      required
                      maxLength={80}
                      placeholder={staticText[formData.nationality]?.insertNatRapporto}
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                    />
                    {errors.relTitolare && <span className="text-red-600 text-sm">{errors.relTitolare}</span>}
                  </div>
                  <p className="text-sm text-gray-600">
                    {formData.relTitolare.length} / 80
                  </p>

                  <div className="mr-4 mt-5 flex items-center">
                    <input
                      type="radio"
                      name="pepTitolareOption"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      checked={formData.pepTitolareOption === "nonPepTitolare"} // Check if it's nonPepTitolare
                      onChange={() => handlePepTitolareChange(false)} // Pass 'false' for "nonPep"
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: staticText[formData.nationality]?.nonPepTitolare || ''
                        }}
                      />  - {" "}
                      <span className="relative cursor-pointer">
                        PEP
                        <FaInfoCircle
                          data-tooltip-id="pepTooltip"
                          data-tooltip-html={tooltip[formData.nationality]?.tooltipPep}// Tooltip content
                          className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4 hidden sm:inline-block"
                          size={13}
                        />
                        {staticText[formData.nationality]?.pepNazionale}
                      </span>
                    </label>
                  </div>

                  {/* Radio button "il Titolare Effettivo costituisce persona politicamente esposta" */}
                  <div className="mr-4 mt-5 flex items-center">
                    <input
                      type="radio"
                      name="pepTitolareOption"
                      className="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-none shadow hover:shadow-md border border-slate-300 checked:bg-[#7B1C3E] checked:border-[#7B1C3E]"
                      checked={formData.pepTitolareOption === "pepTitolare"} // Check if it's pepTitolare
                      onChange={() => handlePepTitolareChange(true)} // Pass 'true' for "pep"
                    />
                    <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-white" // Adjust size of the checkmark (same as checkbox)
                        viewBox="-2 0 19 19"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                    <label className="ml-2 block text-gray-700">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: staticText[formData.nationality]?.pepTitolare || ''
                        }}
                      /> - {" "}
                      <span className="relative cursor-pointer">
                        PEP
                        {staticText[formData.nationality]?.pepNazionale}
                      </span>
                    </label>
                  </div>

                  <div
                    className={`overflow-hidden transition-[height] duration-1000 ease-in-out ${isPepTitolareSelected ? "h-auto max-h-[150px] mt-5" : "h-0"
                      }`}
                  >
                    <textarea
                      name="pepTitolareText"
                      value={formData.pepTitolareText}
                      onChange={handleInputChange}
                      required={formData.pepTitolareOption === "pepTitolare"} // Make textarea required if PEP is selected
                      maxLength={200}
                      placeholder={staticText[formData.nationality]?.insertTextPep}
                      rows="3"
                      className="p-2 border border-gray-300 rounded-md w-full"
                    />
                    <p className="text-sm text-gray-600">
                      {formData.pepTitolareText.length} / 200
                    </p>
                    {errors.pepTitolareText && <span className="text-red-600 text-sm">{errors.pepTitolareText}</span>}
                  </div>

                </>
              ) :
                (
                  <>
                    <div>
                      <ReactTooltip id="opTooltip" place="top" />

                      <h5 className="mt-10 text-center font-bold">
                        {staticText[formData.nationality]?.infoProf}
                      </h5>
                      <div className="mb-4 mt-10">
                        <label className="block text-gray-700">
                          {staticText[formData.nationality]?.profCli} (*)
                        </label>
                        <input
                          type="text"
                          value={formData.profCli}
                          name="profCli"
                          onChange={handleInputChange}
                          maxLength={150}
                          required
                          className="w-full mt-1 p-2 border border-gray-300 rounded-md"

                        />
                        <p className="text-sm text-gray-600">
                          {formData.profCli.length} / 150
                        </p>
                        {errors.profCli && <span className="text-red-600 text-sm">{errors.profCli}</span>}
                      </div>

                      <h5 className="mt-20 text-center font-bold">
                        {staticText[formData.nationality]?.rapporto}
                        <span className="relative cursor-pointer" style={{ marginLeft: "4px" }}>
                          {/* Add margin for spacing */}
                          <FaInfoCircle
                            data-tooltip-id="opTooltip"
                            data-tooltip-html={tooltip[formData.nationality]?.tooltipOp}// Enable HTML in tooltip
                            className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4"
                            size={13}

                          />
                        </span>
                      </h5>
                      <p className="mb-4 mt-10">
                        {staticText[formData.nationality]?.tipRapporto}
                      </p>
                      <div className="tipoRapporto">
                        <div className="mb-4 flex flex-wrap">
                          {[
                            { key: "mandatoVendereBeni", label: "Mandato a vendere di beni", labelEn: 'Mandate to sell goods' },
                            { key: "compravenditaBeni", label: "Compravendita di beni (in asta o trattativa privata)", labelEn: 'Sale of goods (in auction or private negotiation)' },
                            { key: "consulenza", label: "Consulenza", labelEn: 'Consultancy' },
                            { key: "stime", label: "Stime", labelEn: 'Estimation' },
                          ].map(({ key, label, labelEn }) => (
                            <div className="mr-4 flex items-center" key={key}>
                              <input
                                type="checkbox"
                                className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                                disabled={formData.altroTipRapporto}
                                checked={formData[key]}
                                onChange={() => handleCheckboxTipRapportoChange(key)}
                              />
                              <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                                  viewBox="0 0 16 20"
                                  fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="1"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                              <label className=" ml-2 text-gray-700">{formData.nationality === "en" ? labelEn : label}</label>
                            </div>
                          ))}
                          <div className="mr-4 flex items-center">
                            <input
                              type="checkbox"
                              className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                              name="altroTipRapporto"
                              checked={formData.altroTipRapporto}
                              onChange={handleAltroTipRapportoChange}
                            />
                            <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                                viewBox="0 0 16 20"
                                fill="currentColor"
                                stroke="currentColor"
                                strokeWidth="1"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </span>
                            <label className="ml-2 text-gray-700">{formData.nationality === "en" ? "Other" : "Altro"}</label>
                          </div>
                        </div>
                        {formData.altroTipRapporto && (
                          <div className="mt-4">
                            <textarea
                              id="altroRapporto"
                              name="altroTipRapportoDescription"
                              value={formData.altroTipRapportoDescription}
                              maxLength={100}
                              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                              placeholder={staticText[formData.nationality]?.insertTipRapporto}
                              onChange={handleAltroDescriptionChange}
                            />
                            <p className="text-sm text-gray-600">
                              {formData.altroTipRapportoDescription.length} / 100
                            </p>
                          </div>
                        )}
                      </div>

                      <p className="mb-4 mt-10">{staticText[formData.nationality]?.scRapporto}</p>
                      <div className="scopoRapporto">
                        <div className="mb-4 flex flex-wrap">
                          {[
                            { key: "investimentoPersonale", label: "Investimento personale", labelEn: 'Personal investment' },
                            { key: "investimentoProfessionale", label: "Investimento professionale", labelEn: 'Professional investment' },
                            { key: "smobilizzoInvestimento", label: "Smobilizzo di investimento mobiliare / immobiliare", labelEn: 'Movable / Real estate disinvestment' },
                            { key: "investimentoCommerciale", label: "Investimento commerciale / aziendale", labelEn: 'Corporate and business investment' },
                          ].map(({ key, label, labelEn }) => (
                            <div className="mr-4 flex items-center" key={key}>
                              <input
                                type="checkbox"
                                className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox "
                                disabled={formData.altroScRapporto}
                                checked={formData[key]}
                                onChange={() => handleScCheckboxChange(key)}
                              />
                              <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                                  viewBox="0 0 16 20"
                                  fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="1"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                              <label className="ml-2 text-gray-700">{formData.nationality === "en" ? labelEn : label}
                              </label>
                            </div>
                          ))}
                          <div className="mr-4 flex items-center">
                            <input
                              type="checkbox"
                              className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                              name="altroScRapporto"
                              checked={formData.altroScRapporto} // Use formData for persistence
                              onChange={handleAltroScRapportoChange}
                            />
                            <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                                viewBox="0 0 16 20"
                                fill="currentColor"
                                stroke="currentColor"
                                strokeWidth="1"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </span>
                            <label className="ml-2 text-gray-700">{formData.nationality === "en" ? "Other" : "Altro"}
                            </label>
                          </div>
                        </div>
                        {formData.altroScRapporto && (
                          <div className="mt-4">
                            <textarea
                              id="altroRapporto"
                              name="altroScRapportoDescription"
                              value={formData.altroScRapportoDescription}
                              maxLength={100}
                              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                              placeholder={staticText[formData.nationality]?.insertScRapporto}
                              onChange={handleAltroScDescriptionChange}
                            />
                            <p className="text-sm text-gray-600">
                              {formData.altroScRapportoDescription.length} / 100
                            </p>
                          </div>

                        )}
                      </div>

                      <h5 className="mt-20 text-center font-bold">{staticText[formData.nationality]?.dichiara2}</h5>
                      <p className="mt-10 mb-5" style={{ whiteSpace: "pre-line" }}>
                        {staticText[formData.nationality]?.dichiarazione}
                      </p>

                      <AllegatoAccordion formData={formData} />

                      <h5 className="mt-10 text-center font-bold">{staticText[formData.nationality]?.impegna}</h5>
                      <p className="mt-10" style={{ whiteSpace: "pre-line" }}>
                        {staticText[formData.nationality]?.impegno}
                      </p>

                      <div className="mb-4 mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10">
                        <div className="mb-4">
                          <label className="block text-gray-700">
                            {staticText[formData.nationality]?.luogoForm} (*)
                          </label>
                          <input
                            type="text"
                            value={formData.luogoForm}
                            name="luogoForm"
                            onChange={handleInputChange}
                            required
                            maxLength={50}
                            placeholder={staticText[formData.nationality]?.insertLuogoCompilazione}
                            className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                          />
                          {errors.luogoForm && (
                            <span className="text-red-600 text-sm">{errors.luogoForm}</span>
                          )}
                        </div>
                        <div className="mb-4">
                          <label className="block text-gray-700">{staticText[formData.nationality]?.dataForm}</label>
                          <input
                            type="text"
                            value={formData.dataForm}
                            name="dataForm"
                            disabled
                            onChange={handleInputChange}
                            className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                          />
                        </div>
                      </div></div>
                  </>
                )}
            </>
          )}

          {page === 9 && (
            isTitolareSelected ? (
              <>
                <div>
                  <ReactTooltip id="opTooltip" place="top" />

                  <h5 className="mt-10 text-center font-bold">
                    {staticText[formData.nationality]?.infoProf}
                  </h5>
                  <div className="mb-4 mt-10">
                    <label className="block text-gray-700">
                      {staticText[formData.nationality]?.profCli} (*)
                    </label>
                    <input
                      type="text"
                      value={formData.profCli}
                      name="profCli"
                      onChange={handleInputChange}
                      maxLength={150}
                      required
                      className="w-full mt-1 p-2 border border-gray-300 rounded-md"

                    />
                    <p className="text-sm text-gray-600">
                      {formData.profCli.length} / 150
                    </p>
                    {errors.profCli && <span className="text-red-600 text-sm">{errors.profCli}</span>}
                  </div>

                  <h5 className="mt-20 text-center font-bold">
                    {staticText[formData.nationality]?.rapporto}
                    <span className="relative cursor-pointer" style={{ marginLeft: "4px" }}>
                      {/* Add margin for spacing */}
                      <FaInfoCircle
                        data-tooltip-id="opTooltip"
                        data-tooltip-html={tooltip[formData.nationality]?.tooltipOp} // Enable HTML in tooltip
                        className="ml-1 inline-block text-black-100 w-50 absolute -top-2 -right-4"
                        size={13}

                      />
                    </span>
                  </h5>
                  <p className="mb-4 mt-10">
                    {staticText[formData.nationality]?.tipRapporto}

                  </p>
                  <div className="tipoRapporto">
                    <div className="mb-4 flex flex-wrap">
                      {[
                        { key: "mandatoVendereBeni", label: "Mandato a vendere di beni", labelEn: 'Mandate to sell goods' },
                        { key: "compravenditaBeni", label: "Compravendita di beni (in asta o trattativa privata)", labelEn: 'Sale of goods (in auction or private negotiation)' },
                        { key: "consulenza", label: "Consulenza", labelEn: 'Consultancy' },
                        { key: "stime", label: "Stime", labelEn: 'Estimation' },
                      ].map(({ key, label, labelEn }) => (
                        <div className="mr-4 flex items-center" key={key}>
                          <input
                            type="checkbox"
                            className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                            disabled={formData.altroTipRapporto}
                            checked={formData[key]}
                            onChange={() => handleCheckboxTipRapportoChange(key)}
                          />
                          <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                              viewBox="0 0 16 20"
                              fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="1"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          </span>
                          <label className=" ml-2 text-gray-700">{formData.nationality === "en" ? labelEn : label}</label>
                        </div>
                      ))}
                      <div className="mr-4 flex items-center">
                        <input
                          type="checkbox"
                          className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                          name="altroTipRapporto"
                          checked={formData.altroTipRapporto}
                          onChange={handleAltroTipRapportoChange}
                        />
                        <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                            viewBox="0 0 16 20"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="1"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </span>
                        <label className="ml-2 text-gray-700">{formData.nationality === "en" ? "Other" : "Altro"}</label>
                      </div>
                    </div>
                    {formData.altroTipRapporto && (
                      <div className="mt-4">
                        <textarea
                          id="altroRapporto"
                          name="altroTipRapportoDescription"
                          value={formData.altroTipRapportoDescription}
                          maxLength={100}
                          className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                          placeholder={staticText[formData.nationality]?.insertTipRapporto}
                          onChange={handleAltroDescriptionChange}
                        />
                        <p className="text-sm text-gray-600">
                          {formData.altroTipRapportoDescription.length} / 100
                        </p>
                      </div>
                    )}
                  </div>

                  <p className="mb-4 mt-10">{staticText[formData.nationality]?.scRapporto}
                  </p>
                  <div className="scopoRapporto">
                    <div className="mb-4 flex flex-wrap">
                      {[
                        { key: "investimentoPersonale", label: "Investimento personale", labelEn: 'Personal investment' },
                        { key: "investimentoProfessionale", label: "Investimento professionale", labelEn: 'Professional investment' },
                        { key: "smobilizzoInvestimento", label: "Smobilizzo di investimento mobiliare / immobiliare", labelEn: 'Movable / Real estate disinvestment' },
                        { key: "investimentoCommerciale", label: "Investimento commerciale / aziendale", labelEn: 'Corporate and business investment' },
                      ].map(({ key, label, labelEn }) => (
                        <div className="mr-4 mb-4  flex items-center" key={key}>
                          <input
                            type="checkbox"
                            className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox "
                            disabled={formData.altroScRapporto}
                            checked={formData[key]}
                            onChange={() => handleScCheckboxChange(key)}
                          />
                          <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                              viewBox="0 0 16 20"
                              fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="1"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          </span>
                          <label className="ml-2 text-gray-700">{formData.nationality === "en" ? labelEn : label}</label>
                        </div>
                      ))}
                      <div className="mr-4 mb-4 flex items-center">
                        <input
                          type="checkbox"
                          className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 custom-checkbox"
                          name="altroScRapporto"
                          checked={formData.altroScRapporto} // Use formData for persistence
                          onChange={handleAltroScRapportoChange}
                        />
                        <span className="absolute text-white opacity-0 peer-checked:opacity-100 transform  pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 text-white" // Make sure it's white and fits inside the checkbox
                            viewBox="0 0 16 20"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="1"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </span>
                        <label className="ml-2 text-gray-700">{formData.nationality === "en" ? "Other" : "Altro"}</label>
                      </div>
                    </div>
                    {formData.altroScRapporto && (
                      <div className="mt-4">
                        <textarea
                          id="altroRapporto"
                          name="altroScRapportoDescription"
                          value={formData.altroScRapportoDescription}
                          maxLength={100}
                          className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                          placeholder={staticText[formData.nationality]?.insertScRapporto}
                          onChange={handleAltroScDescriptionChange}
                        />
                        <p className="text-sm text-gray-600">
                          {formData.altroScRapportoDescription.length} / 100
                        </p>
                      </div>

                    )}
                  </div>

                  <h5 className="mt-20 text-center font-bold">{staticText[formData.nationality]?.dichiara2}</h5>
                  <p className="mt-10 mb-5" style={{ whiteSpace: "pre-line" }}>
                    {staticText[formData.nationality]?.dichiarazione}
                  </p>

                  <AllegatoAccordion formData={formData} />

                  <h5 className="mt-10 text-center font-bold">{staticText[formData.nationality]?.impegna}</h5>
                  <p className="mt-10" style={{ whiteSpace: "pre-line" }}>
                    {staticText[formData.nationality]?.impegno}
                  </p>

                  <div className="mb-4 mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10">
                    <div className="mb-4">
                      <label className="block text-gray-700">
                        {staticText[formData.nationality]?.luogoForm} (*)
                      </label>
                      <input
                        type="text"
                        value={formData.luogoForm}
                        name="luogoForm"
                        onChange={handleInputChange}
                        required
                        maxLength={50}
                        placeholder={staticText[formData.nationality]?.insertLuogoCompilazione}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                      {errors.luogoForm && (
                        <span className="text-red-600 text-sm">{errors.luogoForm}</span>
                      )}
                    </div>
                    <div className="mb-4">
                      <label className="block text-gray-700">{staticText[formData.nationality]?.dataForm}</label>
                      <input
                        type="text"
                        value={formData.dataForm}
                        name="dataForm"
                        disabled
                        onChange={handleInputChange}
                        className="w-full mt-1 p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div></div>
              </>
            ) : (
              <LastPage
                formData={formData}
                setFormData={setFormData}
                onCodeValidation={handleCodeValidation}
                errors_={errors}
                validateFields={validateFields}
              />
            )

          )
          }


          {(page === 10 && isTitolareSelected) && (
            <LastPage formData={formData} setFormData={setFormData} onCodeValidation={handleCodeValidation} errors_={errors} validateFields={validateFields} />
          )}

          {page === 11 && (
            <div className="flex justify-center items-center mt-20">
              <div className="bg-white border border-gray-300 rounded-lg shadow-lg p-5 max-w-3xl">
                <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                  {staticText[formData.nationality]?.registrazione}   </h1>
                <p className="text-lg text-gray-700 mb-3 text-center">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: staticText[formData.nationality]?.success || ''
                    }}
                  />{" "}
                  <b>{formData.cellulare}</b>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: staticText[formData.nationality]?.success2 || ''
                    }}
                  />
                </p>

              </div>
            </div>

          )}

          <ReactTooltip id="pepTooltip" place="top" />
          <ReactTooltip id="titolareTooltip" place="top" />
          <ReactTooltip id="ricTooltip" place="top" />
          <ReactTooltip id="terTooltip" place="top" />
          <ReactTooltip id="decTooltip" place="top" />
          <ReactTooltip id="prestTooltip" place="top" />




          <div className="flex justify-between mt-6">
            {page > 1 && (isTitolareSelected ? page !== totalPages : page !== totalPages + 1) && (
              <button
                type="button"
                onClick={prevPage}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
              >
                {staticText[formData.nationality]?.indietro}

              </button>
            )}
            {/* <img src="/images/logo_MEETINGART.png" alt="Meeting Art Logo" />  && (isTitolareSelected ? page !== totalPages : page !== totalPages + 1) */}

            {page > 1 && page < totalPages && page !== totalPages - 1 && page !== 5 && page !== 4 && (
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={nextPage}
                  className="px-4 py-2 text-white rounded-md primary-color"
                >
                  {staticText[formData.nationality]?.avanti}

                </button>
              </div>
            )}

            {page === 4 && (
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={nextPage}
                  className={`px-4 py-2 text-white rounded-md ${canProceed ? "primary-color" : "bg-gray-400 cursor-not-allowed"
                    }`}
                  disabled={!canProceed}
                >
                  {staticText[formData.nationality]?.avanti}

                </button>
              </div>
            )}



            {page === 5 && (
              <button
                type="button"
                onClick={nextPage}
                className={`px-4 py-2 text-white rounded-md ${isAvantiEnabled ? "primary-color" : "bg-gray-400 cursor-not-allowed"
                  }`}
                disabled={!isAvantiEnabled}
              >
                {staticText[formData.nationality]?.avanti}

              </button>
            )}

            {(page === totalPages + 1 || (isTitolareSelected && page === totalPages)) && (
              <button
                type="button"
                className="px-4 py-2 mt-5 text-white rounded-md primary-color justify-end"
                style={{ marginLeft: "auto", display: "block" }}
                onClick={() => window.location.href = "https://meetingart.it/"}
              >
                {staticText[formData.nationality]?.home}

              </button>
            )}


            {page === totalPages - 1 && (
              <button
                type="submit"
                className={`px-4 py-2 flex items-center justify-center gap-2 rounded-md ${(!isCodeValid || formData.authCode === "") ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 text-white"}`}
                disabled={!isCodeValid || loading || formData.authCode === ""}
              >
                {loading ? (
                  <span className="animate-spin h-5 w-5 border-4 border-gray-300 border-t-white rounded-full"></span>
                ) : (
                  staticText[formData.nationality]?.invia

                )}
              </button>
            )}
          </div>

          {page == 1 && (
            <div className="flex justify-end">
              <button
                type="button"
                onClick={nextPage}
                className="px-4 py-2 text-white rounded-md primary-color"
              >
                {formData.nationality === "" ? "Avanti" : staticText[formData.nationality]?.avanti}
              </button>
            </div>
          )}
        </div>
      </form>
    </div>

  );

}


export default App;
